
const translations = {
    "Notice!": "Įspėjimas!",
    "Are you sure that you want to delete this?": "Ar tikrai norite tai ištrinti?",
    "Confirm": "Patvirtinti",
    "Cancel": "Atšaukti",
    "Min": "Min.",
    "Max": "Maks.",
    "Before": "Prieš",
    "After": "Po",
    "w": "sav.",
    "week": "savaitė",
    "weeks": "savaitės",
    "d": "d.",
    "day": "diena",
    "days": "dienų",
    "Due date": "Terminas",
    "Start date": "Pradžios data",
    "Internal date": "Vidaus data",
    "Notes": "Pastabos",
    "Document": "Dokumentas",
    "Email": "El. paštas",
    "Billing": "Atsiskaitymas",
    "Add": "Pridėti",
    "Archived": "Suarchyvuota",
    "Cancelled": "Atšaukta",
    "Active": "Aktyvus",
    "Inactive": "Neaktyvus",
    "Client company": "Kliento įmonė",
    "General info": "Bendroji info(Edited)Restore original",
    "Digitisation of client documents": "Kliento dokumentų skaitmeninimas",
    "Client portal": "Klientų portalas",
    "Documents": "Dokumentai",
    "Members": "Nariai",
    "Preferences": "Nuostatos",
    "Yes": "Taip",
    "No": "Ne",
    "Total hours": "Iš viso valandų",
    "Extra hours": "Papildomos valandos",
    "Client": "Klientas",
    "Tasks": "Užduotys",
    "Disable Uku’s task templates": "Išjungti „„Uku\"\" užduočių šablonus",
    "Set the estimation as time when the exact value is not entered": "Nustatykite įvertinimą kaip laiką, kai neįvedama tiksli reikšmė",
    "Checklist must be completed to finish the task": "Norint atlikti užduotį, reikia užpildyti kontrolinį sąrašą",
    "Disable topic management for members": "Išjungti temų valdymą nariams",
    "Disable time edit for members": "Išjungti laiko redagavimą nariams",
    "Allow time entries in future": "Leisti laiko įrašus ateityje",
    "Show all dependent tasks in the calendar": "Rodyti visas susijusias užduotis kalendoriuje",
    "Clients": "Klientai",
    "Disable adding new clients for members": "Išjungti naujų klientų įtraukimą nariams",
    "Only administrators can edit documents": "Redaguoti dokumentus gali tik administratoriai",
    "Allow digitisation of client documents": "Leidimas skaitmeninti klientų dokumentus",
    "Use my Microsoft account": "Naudoti mano „Microsoft“ paskyrą",
    "Disconnect my Microsoft account": "Atjungti mano „Microsoft“ paskyrą",
    "Connect my Microsoft account": "Prijungti mano „Microsoft“ paskyrą",
    "Use my google account": "Naudoti mano „Google“ paskyrą",
    "Connect my google account": "Prijungti mano „Google“ paskyrą",
    "Disconnect my google account": "Atjungti mano „Google“ paskyrą",
    "Emails": "El. laiškai",
    "Daily agenda": "Dienos dienotvarkė",
    "Unread notifications": "Neperskaityti pranešimai",
    "Task assigned to me": "Man paskirta užduotis",
    "Weekly summary": "Savaitės suvestinė",
    "Monthly summary": "Mėnesio suvestinė",
    "Updates and tips": "Atnaujinimai ir patarimai",
    "Overdue": "Pradelsta",
    "1 day": "1 diena",
    "1 day overdue": "1 diena pradelsta",
    "{0} days": "{0} dienos",
    "{0} days overdue": "Pavėluota {0} d",
    "{0} minute ago": "{0} prieš minutę",
    "{0} minutes ago": "{0} prieš kelias minutes",
    "{0} hour ago": "{0} prieš valandą",
    "{0} hours ago": "{0} prieš keletą valandų",
    "Sunday": "Sekmadienis",
    "Monday": "Pirmadienis",
    "Tuesday": "Antradienis",
    "Wednesday": "Trečiadienis",
    "Thursday": "Ketvirtadienis",
    "Friday": "Penktadienis",
    "Saturday": "Šeštadienis",
    "Sun": "S.",
    "Mon": "P.",
    "Tue": "A.",
    "Wed": "T.",
    "Thu": "K.",
    "Fri": "Pn.",
    "Sat": "Š.",
    "January": "Sausis",
    "February": "Vasaris",
    "March": "Kovas",
    "April": "Balandis",
    "May": "geg.",
    "June": "Birželis",
    "July": "Liepa",
    "August": "Rugpjūtis",
    "September": "Rugsėjis",
    "October": "Spalis",
    "November": "Lapkritis",
    "December": "Gruodis",
    "Jan": "saus.",
    "Feb": "vas.",
    "Mar": "kovas",
    "Apr": "bal.",
    "Jun": "birž",
    "Jul": "liepa",
    "Aug": "rugp.",
    "Sep": "rugs.",
    "Oct": "spalis",
    "Nov": "lapkr.",
    "Dec": "gr.",
    "Today": "Šiandien",
    "Yesterday": "Vakar",
    "Day": "Diena",
    "Days": "Dienos",
    "+{0} d": "+ {0} d",
    "+{0} wd": "+ {0} savaitės d.",
    "Weekly {0}": "Kas savaitę {0}",
    "Every {0}. week {1}": "Kas {0}. savaitę {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Kas mėnesį {0}. d",
    "Every {0}. month {1}. d": "Kas {0}. mėnėsį {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Kas ketvirtį {0}. mėnesį {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Kas {0}. ketvirtė {1}. mėnesį {2}. d",
    "{0}. month {1}. d": "{0}. mėnuo {1}. d",
    "Yearly {0}": "Kasmet {0}",
    "Every {0}. year {1}": "Kas {0}. metus {1}",
    "Mo": "P",
    "Tu": "A",
    "We": "T",
    "Th": "K",
    "Fr": "Pn",
    "Sa": "Š",
    "Su": "S",
    "and": "ir",
    "{0}w": "{0} sav.",
    "{0}d": "{0} d.",
    "before": "prieš",
    "after": "po",
    "Project": "Projektas",
    "Quarter": "Ketvirtis",
    "Add your photo": "Pridėkite savo nuotrauką",
    "Adding file failed": "Nepavyko pridėti failo",
    "Please check the file.": "Patikrinkite failą.",
    "You can only add pictures.": "Galite pridėti tik nuotraukas.",
    "Error": "Klaida",
    "Create new topic": "Sukurti naują temą",
    "Name": "Vardas",
    "Close": "Uždaryti",
    "Find topic...": "Rasti temą ...",
    "New topic": "Nauja tema",
    "Invalid format": "Netinkamas formatas",
    "Demo company account": "Bandomoji įmonės paskyra",
    "Demo account will be deleted later. Do this for testing purposes only!": "Bandomoji paskyra vėliau bus ištrinta. Susikurkite šią paskyrą tik bandymo tikslu!",
    "Subscribe": "Prenumeruoti",
    "Start demo": "Pradėti demonstraciją",
    "End demo": "Baigti demonstraciją",
    "Free trial is expired - {0}": "Baigėsi nemokama bandomoji versija - {0}",
    "Free trial {1} {2} left - {0}": "Nemokamos bandomosios versijos {1} {2} liko - {0}",
    "Add time": "Pridėti laiką",
    "Billable": "Apmokestinama",
    "Date": "Data",
    "Start": "Pradžia",
    "End": "Pabaiga",
    "Duration": "Trukmė",
    "Split duration equally": "Paskirstykite trukmę vienodai",
    "Required field": "Privalomas laukelis",
    "Members list": "Narių sąrašas",
    "Edit fields": "Redaguoti laukelius",
    "Maximum number of selected columns has been exceeded": "Viršytas maksimalus pasirinktų stulpelių skaičius",
    "If you want to add a new column to the report, please remove an existing one first.": "Jei norite prie ataskaitos pridėti naują stulpelį, pirmiausia pašalinkite esamą.",
    "Snooze until...": "Atidėti iki ...",
    "Select date & time": "Pasirinkite datą ir laiką",
    "Tomorrow": "Rytoj",
    "Later this week": "Vėliau šią savaitę",
    "Next week": "Kitą savaitę",
    "Add task": "Pridėti užduotį",
    "Checklist": "Kontrolinis sąrašas",
    "Start timer": "Įjungti laikmatį",
    "Add an item": "Pridėti elementą",
    "Add checklist item": "Pridėti kontrolinio sąrašo elementą",
    "Convert to a task": "Konvertuoti į užduotį",
    "Delete": "Ištrinti",
    "Delegate to...": "Deleguoti kam...",
    "Please select tasks from the same account": "Pasirinkite užduotis iš tos pačios paskyros",
    "Follow": "Sekti",
    "Expand sidebar": "Išskleisti šoninę juostą",
    "Nicely done!": "Puikiai padaryta!",
    "You've finished all your tasks, take a second to recharge": "Atlikote visas savo užduotis. Skirkite sekundę atsipūsti",
    "Search tasks...": "Ieškoti užduočių...",
    "Search": "Paieška",
    "select/unselect all": "pažymėti / atžymėti visus",
    "Add new client": "Pridėti naują klientą",
    "Account": "Sąskaita",
    "Client name": "Kliento pavadinimas",
    "Select client": "Pasirinkite klientą",
    "New client": "Naujas klientas",
    "Must be an integer": "Turi būti sveikas skaičius",
    "Must be a number": "Turi būti skaičius",
    "Dashboard": "Prietaisų skydelis",
    "Calendar": "Kalendorius",
    "Report": "Ataskaita",
    "Monitoring": "Stebėjimas",
    "Suppliers": "Tiekėjai",
    "Events": "Renginiai",
    "Projects": "Projektai",
    "Help": "Pagalba",
    "Settings & Apps": "Nustatymai ir programos",
    "Profile": "Profilis",
    "Collapse menu": "Sutraukti meniu",
    "Expand menu": "Išplėsti meniu",
    "Are you sure to delete this attachment?": "Ar tikrai norite ištrinti šį priedą?",
    "Select": "Pasirinkti",
    "Edit contacts": "Redaguoti kontaktus",
    "Add member": "Pridėti narį",
    "Add note": "Pridėti pastabą",
    "Open": "Atidaryti",
    "Reports": "Ataskaitos",
    "Billing notes": "Sąskaitų pastabos",
    "Pinned notes": "Prisegti užrašai",
    "Sub-companies": "Subkompanijos",
    "Contacts": "Kontaktai",
    "Event info": "Informacija apie renginį",
    "Project info": "Projekto informacija",
    "Summary": "Santrauka",
    "Task": "Užduotis",
    "Time": "Laikas",
    "Collapse sidebar": "Sugriauti šoninę juostą",
    "Client Overview": "Kliento apžvalga",
    "Event Overview": "Renginio apžvalga",
    "Project Overview": "Projekto apžvalga",
    "Edit client": "Redaguoti klientą",
    "Edit event": "Redaguoti įvykį",
    "Edit project": "Redaguoti projektą",
    "Show all": "Rodyti viską",
    "Collapse": "Suskleisti",
    "by": "pagal",
    "View all": "Peržiūrėti visus",
    "Add company event": "Pridėti įmonės įvykį",
    "Company": "Įmonė",
    "Info": "Informacija",
    "Holiday": "Šventė",
    "All day(s)": "Visą dieną (-as)",
    "End date": "Pababaigos data",
    "From": "Nuo",
    "Until": "Iki",
    "Hours": "Valandos",
    "Link": "Nuoroda",
    "Save": "Išsaugoti",
    "Are you sure that you want to delete this company calendar event?": "Ar tikrai norite ištrinti šį įmonės kalendoriaus įvykį?",
    "Location of client folder in your document management system": "Kliento aplanko vieta dokumentų valdymo sistemoje",
    "Defined main folder": "Nustatytas pagrindinis aplankas",
    "Custom folder": "Pasirinktinis aplankas",
    "Add new role": "Pridėti naują rolę",
    "New role": "Nauja rolė",
    "Access enabled": "Prieiga įgalinta",
    "Waiting for files": "Laukiama failų",
    "Uploaded": "Įkelta",
    "Uploading...": "Įkeliama...",
    "Client members": "Kliento nariai",
    "Email settings": "El. pašto nustatymai",
    "Or connect new email address": "Arba prijunkite naują el. pašto adresą",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Prisijungimas prie „Microsoft Exchange“ arba kito el. pašto serverio (SMTP)",
    "Test email sent": "Bandomasis el. laiškas išsiųstas",
    "Email address": "E.pašto adresas",
    "Reply address": "Atsakymo adresas",
    "Sender name": "Siuntėjo pavadinimas",
    "Who can use?": "Kas gali naudoti?",
    "Client default address": "Numatytasis kliento adresas",
    "Invalid e-mail": "Neteisingas el. pašto adresas",
    "Role": "Vaidmuo",
    "E-mail": "Elektroninis paštas",
    "Mobile phone": "Mobilusis telefonas",
    "Work phone": "Darbo telefonas",
    "Language": "Kalba",
    "Birthday": "Gimtadienis",
    "Are you sure to delete this contact?": "Ar tikrai norite ištrinti šį kontakta?",
    "Manage contact fields": "Kontaktų laukų tvarkymas",
    "Administrative Assistant": "Administracinis Asistentas",
    "Board member": "Valdybos narys",
    "CEO": "Generalinis direktorius",
    "Add contact": "Pridėti kontaktą",
    "Contact person": "Kontaktinis asmuo",
    "Leave page?": "Išeiti iš puslapio?",
    "Changes that you made may not be saved": "Jūsų atlikti pakeitimai gali būti neišsaugoti",
    "Leave": "Išeiti",
    "Super! We're importing your clients...": "Puiku! Importuojame jūsų klientus...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Galite išeiti iš šio puslapio. Kai klientų importavimas bus paruoštas, jums iššoks pranešimas. Tada turėsite patvirtinti tuos klientus, kuriuose norėsite įkelti į „Uku\".",
    "Please wait...": "Prašau palaukti...",
    "Setup API keys": "Sukonfigūruoti API kodus",
    "You have two options": "Turite du pasirinkimus",
    "how to setup API keys": "kaip sukonfigūruoti API kodus",
    "Continue": "Tęsti",
    "Custom import": "Pritaikytas importavimas",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Norint importuoti klientus ir darbų apimtį iš !INTEGRATION, „Uku\" reikia kiekvieno kliento !INTEGRATION API kodų.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Tęsti</span> - „Uku\" automatiškai sukuria API kodus kiekvienam klientui",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Pritaikytas importavimas</span> - „Uku\" prisijungia tik prie esamų UKU API klientų. Prieš importuodami sukurkite !INTEGRATION API raktus rankiniu būdu. Skaityti:",
    "(it takes a lot of time)": "(tai užima daug laiko)",
    "Import Clients": "Add & update data",
    "Country": "Šalis",
    "Please choose your country": "Pasirinkite savo šalį",
    "Password": "Slaptažodis",
    "Start import": "Pradėti importavimą",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Įveskite !INTEGRATION prisijungimo duomenis (tai saugu) ir suteikite vienkartinę prieigą importuoti klientus ir API raktus. Turėkite omenyje, jog kitose naršyklėse būsite atjungti nuo !INTEGRATION.",
    "Update invoice status": "Atnaujinti sąskaitos faktūros būseną",
    "Update now": "Atnaujinti dabar",
    "Daily @ 14:00": "Kasdien 14:00 val.",
    "Daily @ 18:00": "Kasdien 18:00 val.",
    "Updating invoice statuses, please wait...": "Atnaujinamos sąskaitos faktūros būsenos, prašome palaukti...",
    "Your import is ready": "Jūsų importavimas parengtas",
    "In the final step you need to confirm the clients you want to add to uku": "Paskutiniame žingsnyje turite patvirtinti klientus, kuriuos norite įkelti į „Uku\".",
    "Let's go": "Judėkim",
    "Import again": "Importuoti vėl",
    "Do you have new clients to import?": "Ar norite importuoti naujus klientus?",
    "Yes, i do": "Taip, noriu",
    "View last import": "Žiūrėti paskutinį importavimą",
    "Email server": "El. pašto serveris",
    "Email provider": "El. pašto tiekėjas",
    "Host": "Priimantis serveris",
    "Port": "Portas",
    "Security": "Saugumas",
    "Sender email": "Siuntėjo el. paštas",
    "Username": "Vartotojo vardas",
    "Test connection": "Patikrinkite ryšį",
    "How to set up": "Kaip sukonfigūruoti",
    "Only administrators can activate the app": "Programėlę gali aktyvuoti tik administratoriai",
    "You are in the waiting list": "Jūs laukiančiųjų sąraše",
    "We onboard all applicants one by one": "Pažymėkite savo susidomėjimą, ir pranešime jums, kai programa bus prieinama testavimui",
    "Connected": "Prijungta",
    "Activated": "Aktyvuota",
    "Join waiting list": "Prisijunkite",
    "Activate": "Aktyvuoti",
    "Unsubscribe from waiting list": "Išeiti iš laukiančiųjų sąrašo",
    "Deactivate app": "Deaktyvuoti programą",
    "Disconnect": "Atsijungti",
    "Hide expanded content": "Paslėpti išplėstinį turinį",
    "Show trimmed content": "Rodyti apkarpytą turinį",
    "Email not delivered": "El. laiškas nepristatytas",
    "Sent, but fallback to Uku email": "Išsiųsta, bet grįžtama į Uku el. paštą",
    "Unknown error": "Nežinoma klaida",
    "to": "kam",
    "in any minute": "bet kurią minutę",
    "on {0},": "{0},",
    "or": "arba",
    "Send now": "Siųsti dabar",
    "Uku <span class='subtitle-2'>is sending</span> email": "„Uku“ <span class='subtitle-2'>siunčia</span> el. laišką",
    "__From_email": "__From_email",
    "Set up email": "Konfigūruoti el. paštą",
    "Client default": "Kliento numatytasis",
    "Subject": "Tema",
    "Edit email": "Redaguoti el. laišką",
    "Template": "Šablonas",
    "Cc": "Cc:",
    "Bcc": "Bcc:",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Pridėti šabloną",
    "Add automation": "Pridėti automatizavimą",
    "Add placeholder": "Pridėti vietaženklį",
    "Format text": "Formatuoti tekstą",
    "Add attachment": "Pridėti priedą",
    "Send": "Siųsti",
    "Save automation": "Išsaugoti automatizavimą",
    "Choose email template": "Pasirinkti el. laiško šabloną",
    "All languages": "Visos kalbos",
    "No templates found.": "Šablonų nerasta.",
    "Edit email template": "Redaguoti el. laiško šabloną",
    "Are you sure you want to delete this template? Some tasks will be affected": "Ar tikrai norite ištrinti šį šabloną? Tai paveiks kai kurias užduotis",
    "Are you sure you want to delete this template?": "Ar tikrai norite ištrinti šį šabloną?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Ar tikrai norite išsaugoti šį šabloną, tai paveiks sekančias užduotis?",
    "Template name": "Šablono pavadinimas",
    "Edit template": "Redaguoti šabloną",
    "Send email": "Siųsti el. laišką",
    "on": "kada",
    "Ok": "Gerai",
    "Supplier": "Tiekėjas",
    "Event": "Renginys",
    "Contact": "Kontaktas",
    "Validation failed": "Nepavyko patvirtinti",
    "Saving supplier failed": "Nepavyko išsaugoti tiekėjo",
    "Saving client failed": "Nepavyko išsaugoti kliento",
    "Saving project failed": "Nepavyko išsaugoti projekto",
    "several values": "kelios vertės",
    "values": "vertės",
    "is": "yra",
    "Add filter": "Pridėti filtrą",
    "Update": "Atnaujinti",
    "forever": "amžinai",
    "Last week": "Praeitą savaitę",
    "This week": "Šią savaitę",
    "Last month": "Praeitą mėnesį",
    "This month": "Šį mėnesį",
    "Next month": "Kitą mėnesį",
    "Last year": "Praeitais metais",
    "This year": "Šiais metais",
    "This quarter": "Šį ketvirtį",
    "Next quarter": "Sekantį ketvirtį",
    "Last quarter": "Praeitą ketvirtį",
    "Client group": "Klientų grupė",
    "Topic": "Tema",
    "Member": "Narys",
    "Primary member": "Pirminis narys",
    "Client status": "Kliento būsena",
    "Active clients": "Aktyvūs klientai",
    "Inactive clients": "Neaktyvūs klientai",
    "All": "Visi",
    "Project status": "Projekto būsena",
    "Member status": "Nario būsena",
    "Active members": "Aktyvūs nariai",
    "Limited members": "Ribotas narių skaičius",
    "Inactive members": "Neaktyvūs nariai",
    "Contract status": "Sutarties būsena",
    "Active contracts": "Aktyvios sutartys",
    "Pending contracts": "Laukiančios sutartys",
    "Finished contracts": "Baigtos sutartys",
    "Contract template": "Sutarties šablonas",
    "Payment recurrence": "Mokėjimo pasikartojimas",
    "Yearly": "Kas metus",
    "Monthly": "Kas mėnesį",
    "Trial": "Bandymas",
    "Region": "Regionas",
    "Field": "Laukelis",
    "All tasks": "Visos užduotys",
    "Todo": "„Todo\"",
    "Not done": "Nepadaryta",
    "Done": "Atlikta",
    "Delayed": "Vėluoja",
    "Important": "Svarbu",
    "Extra work": "Papildomas darbas",
    "I Follow": "Aš seku",
    "Commented": "Pakomentavo",
    "Tracked time": "Įvestas laikas",
    "Estimated": "Apskaičiuota",
    "Recurring task": "Pasikartojanti užduotis",
    "Last import": "Paskutinis importavimas",
    "Period": "Laikotarpis",
    "Client search": "Kliento paieška",
    "Voucher": "Kuponas",
    "Company status": "Įmonės statusas",
    "Deleted": "Ištrinta",
    "All status": "Visos būsenos",
    "Payment gateway": "Mokėjimo parinktys",
    "All gateways": "Visi vartai",
    "Uku manually": "Uku rankiniu būdu",
    "Braintree": "Braintree",
    "Plan status": "Plano būklė",
    "All plans": "Visi planai",
    "Paid": "Sumokėta",
    "Paid churn": "Apmokamas atleidimas iš darbo",
    "Trial churn": "Bandomųjų skrydžių nutraukimas",
    "Plan period": "Plano laikotarpis",
    "All periods": "Visi laikotarpiai",
    "Monthly plan": "Mėnesinis planas",
    "Yearly plan": "Metinis planas",
    "Company search": "Įmonės paieška",
    "User search": "Vartotojo paieška",
    "Name key search": "Vardo klavišo paieška",
    "None filter": "Jokio filtro",
    "OK": "Gerai",
    "Start date cannot be later than due date": "Pradžios data negali būti vėlesnė už terminą",
    "tasks": "užduotys",
    "task(s) had errors": "užduotyje (-yse) buvo klaidų",
    "tasks selected": "pasirinktos užduotys",
    "Postpone": "Atidėti",
    "Mark done": "Pažymėti kaip atliktą",
    "Hide multiselect": "Slėpti daugialypį pasirinkimą",
    "Delete task(s)": "Ištrinti užduotį (-is)",
    "All of the data related to the task will be deleted": "Visa informacija, susijusi su užduotimis, bus ištrinta",
    "Some tasks include other people. Are you sure you want to delete?": "Kai kurios užduotys apima kitus žmones. Ar tikrai norite ištrinti?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Kai kurioms pasirinktoms veikloms skirtas laikas buvo stebimas. Ar tikrai norite ištrinti?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Kai kurioms pasirinktoms veikloms skirtas laikas buvo stebimas. Kai kurios užduotys apima kitus žmones. Ar tikrai norite ištrinti?",
    "task(s) were not marked done": "užduotis (-ys) nebuvo pažymėta (-os) kaip atlikta (-os)",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Patikrinkite, ar kontrolinis sąrašas baigtas, ar įvestas laikas ir jie priskirti jums",
    "task(s) were not deleted": "užduotis (-ys) nebuvo ištrinta (os)",
    "task(s) time was not updated": "užduoties (-ių) laikas nebuvo atnaujintas",
    "Please make sure that you can add time to task": "Įsitikinkite, kad galite pridėti laiko prie užduoties",
    "invoice table row": "sąskaitos faktūros lentelės eilutė",
    "invoice table row(s) had errors": "sąskaitos faktūros lentelės eilutėje (-ese) buvo klaidų",
    "invoice table row(s) selected": "sąskaitos faktūros lentelės eilutė (-ės) pasirinkta",
    "Create": "Sukurti",
    "Mark paid": "Pažymėti kaip apmokėta",
    "Send to client": "Siųsti klientui",
    "Recalculate": "Perskaičiuoti",
    "Export to {0}": "Eksportuoti į {0}",
    "Update Status from {0}": "Atnaujinti būseną iš {0}",
    "Void invoice": "Negaliojanti sąskaita faktūra",
    "Delete invoice": "Ištrinti sąskaitą faktūrą",
    "Restore invoice": "Atkurti sąskaitą faktūrą",
    "Mark unpaid": "Pažymėti kaip neapmokėtą",
    "Invoices": "Sąskaitos faktūros",
    "Download to Excel": "ATsisiųsti į Excel'į",
    "Revenue split": "Pajamų paskirstymas",
    "Tax": "Mokesčiai",
    "Description": "Apibūdinimas",
    "Percent": "Procentas",
    "Integration Id": "Integracijos ID",
    "Integration Code": "Integracijos kodas",
    "Name on invoice": "Pavadinimas sąskaitoje faktūroje",
    "Restore": "Atstatyti",
    "Archive": "Archyvas",
    "Hide": "Slėpti",
    "Are you sure?": "Ar esate tikri?",
    "Import finished!": "Importavimas baigtas!",
    "Failed to import {0} records": "Nepavyko importuoti {0} įrašų",
    "Download report": "Atsisiųsti ataskaitą",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Rezultatas: pridėta {0}, atnaujinta {1}, praleista {2}, nepavyko importuoti {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Rezultatas: pridėta {0}, atnaujinta {1}, praleista {2}",
    "What’s next?": "Kas toliau? ",
    "To work effectively with your client base, complete the following steps:": "Atlikite tolimesnius veiksmus, norėdami efektyviai dirbti su savo klientu baze:",
    "Read more ›": "Skaityti daugiau >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Toliau matysite tik aktyvius importuotus klientus. Norėdami pamatyti visus klientus, pašalinkite filtrą „Paskutinis importavimas“.",
    "View clients": "Peržiūrėti klientus",
    "Add <b>primary member</b> to every client.": "Pridėti <b>pirminį narį</b> prie kiekvieno kliento.",
    "Add <b>task plan</b> to automate recurring tasks.": "Pridėti <b>užduoties planą</b> pasikartojančių užduočių automatizavimui.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Nustatykite automatinę mėnesio suvestinę naudodami {0} programą „„Uku\"\", kad importuotumėte darbų apimtį.",
    "Title": "Pavadinimas",
    "Field type": "Laukelio tipas",
    "Field name": "Lauko pavadinimas",
    "Group name": "Grupės pavadinimas",
    "Choices": "Pasirinkimai",
    "Type each choice on a separate line": "Kiekvieną pasirinkimą įveskite atskiroje eilutėje",
    "Required": "Būtina",
    "For all topics": "Visoms temoms",
    "For specific topics": "Konkrečioms temoms",
    "Topics": "Temos",
    "Non-billable": "Neapmokestinama",
    "Edit task custom field": "Redaguoti užduoties pritaikytą laukelį",
    "Add task custom field": "Pridėti užduoties pritaikytą laukelį",
    "Edit client custom field": "Redaguoti kliento pritaikytą laukelį",
    "Add client custom field": "Pridėti kliento pritaikytą laukelį",
    "Choice {0}": "Pasirinkimas {0}",
    "Are you sure that you want to delete this custom field?": "Ar tikrai norite ištrinti šį pritaikytą laukelį?",
    "Warning!": "Įspėjimas!",
    "This custom field is in use. Do you wish to archive it?": "Šis pritaikytas laukelis yra naudojamas. Ar norėtumėt jį suarchyvuoti.",
    "Reconnect": "Iš naujo prijunkite",
    "Send test email": "Siųsti bandomąjį el. laišką",
    "Email address or username": "El. pašto adresas arba vartotojo vardas",
    "Other": "Kita",
    "Set default email server for company": "Nustatyti numatytąjį įmonės el. pašto serverį",
    "My default email": "Mano numatytasis el. pašto adresas",
    "Depends on": "Priklauso nuo",
    "Todo - Blocking": "„Todo\" - Blokavimas",
    "In progress - Blocking": "Vykdoma - Blokavimas",
    "In progress": "Vykdoma",
    "Client code": "Kliento kodas",
    "Primary user": "Pagrindinis vartotojas",
    "Added date": "Pridėta data",
    "Updated": "Atnaujinta",
    "Contract count": "Sutarčių skaičius",
    "Integration": "Integracija",
    "No data available": "Duomenų nėra",
    "No results found": "Rezultatų nerasta",
    "Loading": "Kraunasi",
    "Sort by": "Rūšiuoti pagal",
    "Rows per page": "Eilutės puslapyje",
    "{0}-{1} of {2}": "{0} - {1} iš {2}",
    "Ongoing": "Vyksta",
    "important": "svarbu",
    "Read more": "Skaityti daugiau",
    "Add to previous time entry": "Pridėti prie ankstesnio laiko įrašo",
    "Add to next time entry": "Pridėti prie kito laiko įrašo",
    "Add new task": "Pridėti naują užduotį",
    "Cut previous time entry": "Iškirpti ankstesnį laiko įrašą",
    "Cut next time entry": "Iškirpti kitą laiko įrašą",
    "Missing time entry": "Trūksta laiko įrašo",
    "Overlapping time entries": "Persidengiantys laiko įrašai",
    "Member from custom fields": "Narys iš pasirinktinių laukų",
    "Delegated to": "Kam įgaliota:",
    "Delegated by": "Kas įgaliojo:",
    "Visible members": "Matomi nariai",
    "Member type": "Narės tipas",
    "Groups": "Grupės",
    "Custom field": "Pritaikytas laukelis",
    "Contact search": "Kontaktų paieška",
    "Task start": "Užduoties pradžia",
    "Task due": "Užduotis turi būti įvykdyta",
    "Task finish": "Užduoties užbaigimas",
    "Custom date": "Pasirinktinė data",
    "Never": "Niekada",
    "Agreed work is still expected": "Vis dar tikimasi, kad bus atliktas sutartas darbas",
    "Accepted flextime": "Patvirtintas Flextime",
    "Declined flextime": "Atmestas Flextime",
    "Cancelled flextime": "Atšauktas Flextime",
    "Updated flextime": "Atnaujintas Flextime",
    "Calendar deleted": "Kalendorius ištrintas",
    "Calendar created": "Kalendorius sukurtas",
    "Calendar approved": "Kalendorius patvirtintas",
    "Calendar declined": "Kalendorius atmestas",
    "Calendar updated": "Kalendorius atnaujintas",
    "Flextime balance updated": "Atnaujintas lankstaus darbo laiko balansas",
    "Flextime": "Flextime",
    "Vacation": "Atostogos",
    "Balance": "Likutis",
    "Comment": "Komentaras",
    "History": "Istorija",
    "Action": "Veiksmas",
    "Who": "Kas ",
    "Take a vacation or mark an absence": "Pasiimkite atostogas arba pažymėkite neatvykimą",
    "Away": "Nedirba",
    "Flextime bonus": "Flextime premija",
    "Approver": "Tvirtintojas",
    "Vacation available": "Galimos atostogos",
    "Type": "Tipas",
    "Reduce agreed working hours": "Sutrumpinti sutartas darbo valandas",
    "Reject": "Atmesti",
    "Approve": "Patvirtinti",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Laikinojo nedarbingumo atostogos",
    "Parental leave": "Tėvystės atostogos",
    "Working hours": "Darbo valandų nustatymas",
    "Mon-Fri, 40h weekly, 8h daily": "Pirmadieniais-penktadieniais, 40 val. per savaitę, 8 val. kasdien",
    "Customize": "Tinkinti",
    "Total": "Iš viso",
    "Settings": "Nustatymai",
    "Work on holidays": "Darbas atostogų dienomis",
    "Expand": "Išskleisti",
    "Wait until event status": "Palaukite iki įvykio būsenos",
    "Wait until project status": "Palaukite, kol projekto būsena",
    "Week(s)": "Savaitė (-ės)",
    "Day(s)": "Diena (-os)",
    "Rule": "Taisyklė",
    "Depends on event": "Priklauso nuo įvykio",
    "Depends on project": "Priklauso nuo projekto",
    "Due date in": "Termino data",
    "Status": "Būklė",
    "Select event": "Pasirinkite įvykį",
    "Select project": "Pasirinkite projektą",
    "Find event...": "Raskite renginį...",
    "Find project...": "Raskite projektą...",
    "Custom recurrence": "Pritaikytas pasikartojimas",
    "Every": "Kiekvieną",
    "In case of holiday": "Atostogų atveju",
    "Set time": "Nustatyti laiką",
    "Start time": "Pradžios laikas",
    "Repeat from": "Pakartokite nuo",
    "Previous repeat from: {0}": "Ankstesnis pakartojimas nuo: {0}",
    "On date": "Data",
    "Plus days": "Plius dienos",
    "Due date time": "Termino laikas",
    "Remove recurrence": "Pašalinti pasikartojimą",
    "Repeat": "Pakartoti",
    "month": "mėnesį",
    "quarter": "ketvirtis",
    "year": "metai",
    "1st month": "1-mas mėn.",
    "2nd month": "2-as mėn.",
    "3rd month": "3-ias mėn.",
    "Day {0}": "{0} diena",
    "Show before": "Rodyti anksčiau",
    "Keep the day": "Laikykis dienos",
    "Show after": "Rodyti po",
    "From start date": "Nuo pradžios datos",
    "From beginning of the month": "Nuo mėnesio pradžios",
    "All days (Mon to Sun)": "Visos dienos (nuo pirmadienio iki sekmadienio)",
    "Mon to Fri (incl. holidays)": "Pirmadieniais – penktadieniais (su šventėmis)",
    "Mon to Fri (excl. holidays)": "Pirmadieniais – penktadieniais (išskyrus šventes)",
    "1st": "1-a",
    "2nd": "2-a",
    "3rd": "3-a",
    "Does not repeat": "Nekartoja",
    "Daily": "Kasdien",
    "Weekly on {0}": "Kas savaitę {0}",
    "Monthly on day {0}": "Kas mėnesį {0} dieną",
    "Quarterly on {0} month {1} day": "Kas ketvirtį {0} mėnesį {1} dieną",
    "Yearly on {0} {1}": "Kasmet {0} {1}",
    "Custom...": "Pritaikytas...",
    "Incorrect time": "Netinkamas laikas",
    "Add repeat": "Pridėti kartojimą",
    "Email added to queue": "El. pašto adresas įtrauktas į eilę",
    "Communication timeline": "Bendravimo laiko juosta",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktyvuokite el. pašto programą „App Store“ parduotuvėje, kad galėtumėte siųsti automatinius el. laiškus ir peržiūrėti savo ankstesnius bei būsimus pranešimus vienoje vietoje.",
    "Go to App Store": "Nustatykite programėlę",
    "Unknown": "Nežinoma",
    "<b>Email</b> from": "<b>El. paštas</b> iš",
    "To": "Kam",
    "Planned": "Suplanuota",
    "Automated emails scheduled to be sent in the future": "Automatizuoti el. laiškai suplanuoti siuntimui ateityje",
    "Send e-mail": "Siųsti el. laišką",
    "Template unlinked": "Šablonas atsietas",
    "Icon": "Ikona",
    "Link name": "Nuorodos pavadinimas",
    "Link URL": "Puslapio įkėlimo linkas",
    "Open in new tab": "Atidaryti naujame skirtuke",
    "Visible": "Matoma",
    "External": "Išorinis",
    "Not external": "Ne išorinis",
    "Company default": "Įmonės įsipareigojimų nevykdymas",
    "Not visible": "Nesimato",
    "Use company default": "Naudoti įmonės numatytąsias nuostatas",
    "or choose icon": "arba pasirinkite piktogramą",
    "Find member...": "Surasti narį...",
    "I'll take it": "Paimsiu tai",
    "Remove me": "Pašalinti mane",
    "Remove from task": "Pašalinti iš užduoties",
    "Learn more": "Sužinokite daugiau",
    "Company settings edit is disabled by owner": "Savininkas išjungė įmonės nustatymų redagavimą",
    "<b>Exported</b> {0} to {1}": "<b>Eksportuota iš</b> {0} į {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Išsiųsta klientui</b> {0} iš {1}",
    "<b>Paid {0}</b> {1}": "<b>Apmokėta {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Anuliuotas</b> {0}",
    "Do you wish to mark the task done for everyone?": "Ar norite visiems pažymėti, kad užduotis atlikta?",
    "No, remove me": "Ne, pašalinti mane",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Užduotis nebus pažymėta kaip atlikta, bet vartotojas bus pašalintas iš perėmėjų ir pridėtas prie užduoties sekėjų",
    "Invalid email": "Neteisingas el. pašto adresas",
    "Accounting": "Apskaita",
    "General": "Bendras",
    "Advertising / Marketing/ PR": "Reklama / Rinkodara / PR",
    "Architecture": "Architektūra",
    "Construction": "Statyba",
    "Consulting - IT, software": "Konsultacijos - IT, programinė įranga",
    "Consulting - Management": "Konsultacijos - valdymas",
    "Finance": "Finansai",
    "Legal": "Teisė",
    "Medicine / Pharmacy ": "Medicina / Farmacija ",
    "Non-profit": "Ne pelno",
    "Web design": "Interneto svetainių dizainas",
    "Web development": "Interneto svetainių kūrimas",
    "Max 140 characters": "Maks. 140 simbolių",
    "Please complete the checklist": "Užpildykite kontrolinį sąrašą",
    "It is required to mark all checklist items as done": "Būtina pažymėti visus kontrolinio sąrašo elementus kaip atliktus",
    "Please enter time spent": "Įveskite praleistą laiką",
    "Inserting time is essential for this client": "Šiam klientui būtina įvesti laiką",
    "Only me": "Tik man",
    "Private": "Privatus",
    "Edit note": "Redaguoti pastabą",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Pridėkite papildomos informacijos apie klientą, pvz., specialius susitarimus, slaptažodžius ir kt.",
    "Edit": "Redaguoti",
    "Workdays": "Darbo dienos",
    "Workhours": "Darbo valandos",
    "Weeks": "Savaites",
    "Clear filters": "Išvalyti filtrus",
    "Save filters": "Išsaugoti filtrus",
    "Expected": "Numatoma",
    "Estimation": "Įvertinimas",
    "Do you also want to postpone the due date?": "Ar taip pat norite atidėti terminą?",
    "{0} week": "{0} savaitę",
    "{0} weeks": "{0} savaites",
    "Vacations": "Atostogos",
    "Holidays": "Atostogos",
    "Tax dates": "Mokesčių datos",
    "Accounting news": "Buhalterinės naujienos",
    "Company events": "Įmonės renginiai",
    "Member birthdays": "Narių gimtadieniai",
    "Contact birthdays": "Susisiekite su gimtadieniais",
    "Group items": "Grupės elementai",
    "Don't group": "Negrupuoti",
    "{0} away": "{0} toli",
    "Member birthday | Member birthdays": "Narių gimtadieniai | Narių gimtadieniai",
    "Contact birthday | Contact birthdays": "Kontaktų gimtadienis | Kontaktų gimtadieniai",
    "Contact birthday": "Kontaktinio asmens gimtadienis",
    "Member birthday": "Narių gimtadienis",
    "Are you sure you wish to delete this link?": "Ar tikrai norite ištrinti šią nuorodą?",
    "Reference name": "Nuorodos pavadinimas",
    "Reference link": "Nuoroda",
    "Free trial": "Nemokamas bandymas",
    "Solo": "„Solo\"",
    "Team": "„Team\"",
    "Enterprise": "„Enterprise\"",
    "Mini Uku": "„Mini „Uku\"\"",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "„Chrome“ naršyklės „„Uku\"“ papildinys, skirtas valdyti užduotį, klientus ir stebėti laiką.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Nustatykite užduotį/darbų planus, kad automatizuotumėte darbo eigą, pridėtumėte temų, pritaikytų laukelių ir pakeistumėte savo nuostatas.",
    "Setup client groups, custom fields and modify your preferences.": "Nustatykite klientų grupes, pritaikytus laukelius ir pakeiskite savo nuostatas.",
    "test": "bandymas",
    "Anti Money Laundering": "Kova su pinigų plovimu",
    "Setup your customer AML and get instant reminders when auditing is due.": "Nustatykite kliento AML ir gaukite momentinius priminimus, kai pasibaigia dokumentų galiojimo laikas.",
    "flextime_description": "Lengvai valdykite darbo ir asmeninio gyvenimo pusiausvyrą.",
    "Smart Accounts": "„SmartAccounts“",
    "Automatically imports work statistics from your accounting software.": "Automatiškai importuoja darbo statistiką iš savo apskaitos programinės įrangos.",
    "Merit Aktiva": "„Merit Aktiva“",
    "360 Księgowość": "„360 Księgowość“",
    "Speed up your client billing process with pricelists and smart contracts.": "Paspartinkite kliento atsiskaitymo procesą naudodami kainynus ir išmaniąsias sutartis.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Vizuali ataskaita jums tiksliai parodys, kiek jūsų klientas yra pelningas ar nepelningas.",
    "Emailing description": "Siųskite elektronines žinutes per Uku ir automatizuokite pasikartojančias žinutes",
    "e-conomic": "„e-conomic“",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Sinchronizuokite klientų duomenis iš „Uku“ į „e-conomic“ ir atvirkščiai. Peržiūrėkite kiekvieno kliento didžiosios knygos informaciją.",
    "Xero": "„Xero“",
    "xero_description": "Lengvai importuokite klientus į „Uku“ ir automatizuokite sąskaitų išrašymą.",
    "QuickBooks": "\"QuickBooks\"",
    "quickbooks_description": "Lengvai importuokite klientus į „Uku“ ir automatizuokite sąskaitų išrašymą.",
    "Tripletex": "Tripletex",
    "tripletex_description": "Lengvai importuokite klientus į „Uku“ ir automatizuokite sąskaitų išrašymą.",
    "Scoro": "„Scoro“",
    "Export sales invoices.": "Eksporto pardavimo sąskaitas faktūras.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Lengvai importuokite klientus į „Uku“ ir automatizuokite sąskaitų išrašymą.",
    "Magic button": "Magiškas mygtukas",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Vienu paspaudimu - greitas ir lengvas būdas naujoms užduotims sukurti. Pavyzdžiui, skambutis iš kliento.",
    "With suppliers, you make your projects and partners management more efficient.": "Su tiekėjais efektyvinate savo projektų ir partnerių valdymą.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Galingas ir lankstus projektų valdymas aptarnauja įvairius naudojimo atvejus ir darbo eigą.",
    "client_portal_app_description": "Klientų portalas supaprastina bendradarbiavimą su klientais. Saugiai gaukite dokumentus, pateikite užduotis ir dalinkitės informacija.",
    "Chat": "Pokalbis",
    "chat_app_description": "Pagerinkite komandos bendradarbiavimą, bendravimą su klientais ir bendrą efektyvumą naudodami Pokalbį.",
    "Companies House": "„Companies House”",
    "companies_house_app_description": "Didžiosios Britanijos verslo registro integracija",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Prisijunkite ir atraskite įrankius, kurie padės jums valdyti savo verslą.",
    "Subscribe now": "Prenumeruoti dabar",
    "Compare plans": "Palyginti planus",
    "Add company": "Pridėti įmonę",
    "BETA": "BETA",
    "Setup": "Konfigūracija",
    "Power up": "Įjungti",
    "Integrations": "Integracijos",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Sveiki! Norite dirbti su savo komanda ir naudotis papildomomis funkcijomis? Jokių problemų, pirmiausia pridėkite savo įmonę!",
    "Read more about Uku plans": "Skaityti daugiau apie „Uku“ planus",
    "Contact role": "Kontaktinio asmens rolė",
    "Contact roles": "Kontaktinio asmens rolės",
    "Client groups": "Klientų grupės",
    "Client fields": "Kliento laukai",
    "Contact fields": "Kontaktinio asmens laukai",
    "View archive": "Žiūrėti archyvą",
    "Restore from archive": "Atstatyti iš archyvo",
    "Empty list": "Tuščias sąrašas",
    "Task fields": "Užduočių laukai",
    "task topics": "užduoties temos",
    "Keep the task opened when starting the timer": "Laikykite užduotį atidarytą, kai įjungiate laikmatį",
    "task templates": "užduočių šablonai",
    "Author": "Autorius",
    "Duplicate": "Dublikuoti",
    "Uku task templates": "Uku užduočių šablonai",
    "Are you sure that you want to delete this task template?": "Ar tikrai norite ištrinti šį užduoties šabloną?",
    "Templates": "Šablonai",
    "Overview": "Apžvalga",
    "chat_app_overview_text": "<p class='title’>„Uku“ Pokalbis yra patogus ir saugus pranešimų siuntimo įrankis, pritaikytas bendravimui, bendradarbiavimui ir užduočių valdymui supaprastinti.</p> <div class='body-2'><p>Pagrindinės funkcijos:</p><ul><li>Pranešimų siuntimas realiuoju laiku: siųskite žinutes komandos nariams ir klientams. Yra tiesioginių žinučių, grupinių pokalbių ir konkrečioms temoms skirtų kanalų parinktys.</li><li>Užduočių valdymas: sukurkite naują užduotį iš pokalbio.</li><li>„ChatGPT“ integracija: paprašykite apibendrinti pokalbį, pakeisti kalbos toną ar teisiog bendrų rekomendacijų, kaip atsakyti.</li><li>Pritaikomi pranešimai: pritaikykite pranešimus pagal savo pageidavimus.</li></ul></div>",
    "Color": "Spalva",
    "Are you sure to delete this field? You may lose the data.": "Ar tikrai norite ištrinti šį laukelį? Galite prarasti juose esančią informaciją.",
    "Add field": "Pridėti laukelį",
    "Add section": "Pridėti skyrių",
    "multiline": "kelios eilutės",
    "Import data": "Importuoti duomenis",
    "Automate data collection with Smart Accounts": "Automatizuokite duomenų rinkimą naudodami „Smart Accounts“",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul>    <li>Importuokite pirkimo ir pardavimo įrašus, bendrus įrašus ir jų skaičiavimus;</li><li>Automatizuokite duomenų rinkimą su Smart Accounts;</li><li>Greitesnis ir tikslesnis sąskaitų išrašymas automatizuotų duomenų mainų pagalba. Uku renka informaciją ir paruošia klientų sąskaitas faktūras vienoje vietoje ir dėl to padaro šį procesą daug efektyvesnį.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automatizuokite sąskaitų išrašymo procesą prijungdami „Xero“ prie „Uku“.</p> <div class='body-2'><p>„Xero“ integracijos privalumai:</p><ul><li>Importuokite visus klientus iš „Xero“ į „Uku“ vos keliais paspaudimais</li><li>Importuokite produktų kodus ir klasifikatorius į „Uku“</li><li>automatiškai kurkite sąskaitas faktūras „Uku“ platformoje ir persiųskite jas į „Xero“</li></ul></div>",
    "Import clients from {0}": "Importuoti klientus iš {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Prieš importuodami klientus, turite autorizuoti naudodami „Xero“ ir pasirinkti įmonę.",
    "Authorize Xero to start import": "Leisti „Xero“ pradėti importą",
    "Failed to import clients": "Nepavyko importuoti klientų",
    "Failed to connect to WS": "Nepavyko prisijungti prie WS",
    "Import": "Importuoti",
    "emailing_app_overview_text": "<p class='title'><b>Greitas ir patogus bendravimas su klientais</b></p><div class='body-2'><p>Siųskite pavienius el. laiškus arba nustatykite automatinį reguliarų el. laiškų siuntimą. Abu veiksmus galite atlikti užduoties rodinyje.</p><p><b>Automatizuoti el. laiškai</b></p><p>Prie pasikartojančių užduočių pridėkite automatizuotą el. laiškų siuntimą. Pavyzdžiui, užduočiai „Dokumentų įvedimas“ nustatykite automatinį el. laišką „Trūkstami dokumentai“, kuris bus išsiųstas likus 2 dienoms iki užduoties pradžios. Taip prieš pradėdami dirbti su užduotimi turėsite visus reikiamus dokumentus.</p><p><b>El. laiškų šablonai</b></p><p>Dažnai siunčiamus el. laiškus patogiai išsaugokite kaip šabloną. Taip išvengsite rūpesčių, susijusių su nuolatiniu to paties turinio laiškų kūrimu.</p></div>",
    "Email signatures": "El. pašto parašai",
    "Everyone": "Visiems",
    "Access": "Prieiga",
    "Creator": "Kūrėjas",
    "Are you sure you want to delete this signature? Some emails will be affected": "Ar tikrai norite ištrinti šį parašą? Tai turės įtakos kai kuriems el. laiškams",
    "Email addresses": "El. pašto adresai",
    "Signatures": "Parašai",
    "Send emails": "Siųsti el. laiškus",
    "Uku securely integrates with your email to help you manage and automate communication": "„Uku“ saugiai integruojasi su jūsų el. paštu, kad padėtų jums valdyti ir automatizuoti bendravimą",
    "Use {0} address": "Naudokite {0} adresą",
    "connect your email address": "prijunkite savo el. pašto adresą",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Prisijungimas prie „Microsoft Exchange“ arba kito el. pašto serverio (SMTP)",
    "Email integration reconnected": "Iš naujo prijungta el. pašto integracija",
    "Are you sure you want to delete this email integration?": "Ar tikrai norite ištrinti šią el. pašto integraciją?",
    "Email templates": "El. laiškų šablonai",
    "Add email template": "Pridėti el. laiško šabloną",
    "Are you sure you want to save this template? Some tasks will be affected": "Ar tikrai norite išsaugoti šį šabloną? Tai paveiks kai kurias užduotis",
    "Clients can leave task messages by replying to client portal email": "Klientai gali palikti užduočių pranešimus atsakydami į klientų portalo el. laišką",
    "Send a copy of client's response to member's inbox": "Siųsti kliento atsakymo kopiją į nario pašto dėžutę",
    "Email recipients can leave task comments by replying to a task email": "El. laiškų gavėjai gali palikti užduoties komentarus atsakydami į užduoties el. laišką",
    "economic_app_overview_text": "<p class='title'>Automatizuokite atsiskaitymo procesą prijungdami „e-conomic“ prie „Uku“</p><div class='body-2'><p>„e-conomic“ integracija leidžia:<ul><li>vos keliais paspaudimais importuoti visus savo klientus iš „e-conomic“ į „Uku“</li><li>importuoti produktus ir klasifikatorius iš „e-conomic“ į „Uku“</li><li>automatiškai kurti sąskaitas faktūras „Uku“ platformoje ir persiųsti jas į „e-conomic“</li></ul></p></div>",
    "Default layout": "Numatytasis išdėstymas",
    "Change agreement ID": "Keisti sutarties ID",
    "Failed to connect to server": "Nepavyko prisijungti prie serverio",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.",
    "Connect e-conomic": "Jungti „e-conomic\"",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Prieš importuojant klientus turite įjungti „„Uku\"\" ir „economic\" programas. Kad tai padaryti, sukurkite „economic\" sutartį ir įveskite čia sutarties ID.",
    "Step {0}": "Žingsnis {0}",
    "Get agreement ID": "Gauti sutarties ID",
    "Insert agreement ID": "Įrašyti sutarties ID",
    "Connect": "Įjungti",
    "quickbooks_app_overview_text": "<p class='title'>Automate your billing process by connecting QuickBooks Online to Uku.</p> <div class='body-2'><p>Benefits of the QuickBooks integration:</p><ul><li>Import all your clients from QuickBooks to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "\"Uku\" importuos visus klientus, informaciją apie klientus ir klasifikatorius iš \"QuickBooks\". Paskutiniame žingsnyje galite pasirinkti, kuriuos klientus norite pridėti arba atnaujinti.",
    "Before importing clients, you need to connect with QuickBooks.": "Prieš importuodami klientus turite prisijungti prie \"QuickBooks\".",
    "Connected to QuickBooks": "Prisijungta prie \"QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automate your billing process by connecting Fortnox to Uku.</p> <div class='body-2'><p>Benefits of the Fortnox integration:</p><ul><li>Import all your clients from Fortnox to Uku with just a couple of clicks.</li><li>Import products and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "\"Uku\" importuos visus klientus, klientų informaciją ir klasifikatorius iš \"Fortnox\". Paskutiniame žingsnyje galite pasirinkti, kuriuos klientus norite pridėti arba atnaujinti.",
    "Before importing clients, you need to connect with Fortnox.": "Prieš importuodami klientus turite prisijungti prie \"Fortnox\".",
    "Connect to Fortnox": "Prisijunkite prie \"Fortnox",
    "Connected to Fortnox": "Prijungtas prie \"Fortnox",
    "Delete template": "Ištrinti šabloną",
    "Public": "Viešas",
    "Workflow templates": "Darbo eigos šablonai",
    "No workflow templates yet": "Kol kas nėra darbo eigos šablonų",
    "Modified": "Modifikuota",
    "Uku workflow templates": "Uku darbo eigos šablonai",
    "Are you sure you wish to delete this workflow?": "Ar tikrai norite ištrinti šią darbo eigą?",
    "Project fields": "Projekto laukeliai",
    "Progress step": "Progreso žingsnis",
    "Rename project": "Pervadinti projektą",
    "Project statuses": "Projekto būsenos",
    "You can use the statuses to restrict the workflow.": "Būsenas galite naudoti norėdami apriboti darbo eigą.",
    "Project phases": "Projekto etapai",
    "Make your progress beautiful.": "Padarykite savo progresą gražiu.",
    "Permissions": "Leidimai",
    "Users can manage workflow templates": "Vartotojai gali valdyti darbo eigos šablonus",
    "project_app_overview_text": "Handle projects from initiation to completion with ease.",
    "project_app_overview_description": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Konfigūruoti suvestinės užduotį",
    "Uku will generate task with following title and topic on the last day of the month.": "Paskutinę mėnesio dieną „„Uku\"\" sugeneruos užduotį su tokiu pavadinimu ir tema.",
    "Task title": "Užduoties pavadinimas",
    "Recurrence": "Pasikartojimas",
    "Count changes from previous periods": "Skaičiaus pokyčiai, palyginti su ankstesniais laikotarpiais",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Jei įjungta, ankstesniais laikotarpiais atlikti pakeitimai bus įtraukti į einamąjį mėnesį. Jei išjungta, ankstesniais laikotarpiais atlikti pakeitimai nebus įtraukiami.",
    "Configure data fields": "Konfigūruoti duomenų laukelius",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Kiekvienam importuotam laukui pasirinkite atitinkamą „„Uku\"\" lauką. Tie patys laukai bus apibendrinti. Jei kurį lauką paliksite tuščią, jis bus ignoruojamas.",
    "New custom field": "Naujas pritaikytas laukelis",
    "Show more": "Rodyti daugiau",
    "Every month": "Kiekvieną mėnesį",
    "Last day of the month": "Paskutinė mėnesio diena",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Kito mėnesio {0} diena",
    "Settings saved": "Nustatymai išsaugoti",
    "Uku will let you know when it is ready.": "Uku jums praneš, kai jis bus paruoštas.",
    "Reload data": "Duomenų perkrovimas",
    "months": "mėnesių",
    "This will overwrite existing summary tasks new values.": "Taip bus perrašytos esamos suvestinių užduočių naujos reikšmės.",
    "Overwrite": "Perrašyti",
    "Automate your anti money laundering process": "Automatizuokite kovos su pinigų plovimu procesą",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Šiuo metu jūs ruošiatės aktyvuoti pinigų plovimo prevencijos priemonę. Tai padarius prie jūsų kliento paskyros bus pridėti papildomi kliento duomenų langeliai ir sistema ims jums priminti apie poreikį juos užpildyti.<br><br>Papildomi kliento paskyros laukeliai:<ul><li>Rizikos profilis</il><li>Profilis galioja iki</il><li>Pinigų plovimo prevencijos statusas</il><li>Dokumentas nr.</il><li>Dokumentas galioja iki</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Jūs ruošiatės aktyvuoti kovos su pinigų plovimu procesą. Šio proceso metu prie jūsų klientų duomenų bus įtraukti nauji papildomi laukeliai, o sistema pradės priminti apie jų atnaujinimą.<br><br>Papildomi laukeliai yra:<ul><li>Rizikingas profilis</il><li>Sekantis AML patikrinimas</il><li>Praeita/Nepraeita</il><li>ID tipas</il><li>ID numeris</il><li>Galiojimo datos pabaiga</il><li>Papildomi patikrinimai</li></ul>",
    "Do not change client custom fields created by Uku": "Nekeiskite „„Uku\"“ sukurtų kliento pritaikytų laukų",
    "day(s) before": "diena (-os) prieš",
    "Task name": "Užduoties pavadinimas",
    "Assigned": "Paskirta",
    "Note": "Pastaba",
    "Manual run": "Rankinis paleidimas",
    "Create a task when the document expires": "Sukurkite užduotį pasibaigus dokumento galiojimo laikui",
    "Create a task when the risk profile must be updated": "Sukurkite užduotį, kai reikia atnaujinti rizikingą profilį",
    "Flextime period": "Flextime laikotarpis",
    "Confirmation period": "Patvirtinimo laikotarpis",
    "Weekly": "Kas savaitę",
    "Add agreement": "Pridėti sutartį",
    "flextime_app_overview_text": "<p class='title'>Peržiūrėkite savo komandos darbo valandas, viršvalandžius ir atostogų balansą.</p> <div class='body-2'><p></p><p>Flextime privalumai:</p><ul><li>Patogi darbo ir viršvalandžių apžvalga</li><li>Prieinamas atostogų valdymas ir balanso apžvalga</li><li>Lengvas duomenų eksportas buhalteriui</li></ul></div>",
    "supplier_app_overview_text": "Manage your partners and vendors.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organisations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Tiekėjo tipas",
    "Parent type": "Motininis tipas",
    "Edit supplier type": "Redaguoti tiekėjo tipą",
    "New supplier type": "Naujas tiekėjo tipas",
    "Are you sure you wish to delete this supplier type?": "Ar tikrai norite ištrinti šį tiekėjo tipą?",
    "Types": "Tipai",
    "Supplier types": "Tiekėjų tipai",
    "No supplier types yet": "Kol kas tiekėjų tipų nėra",
    "tripletex_app_overview_text": "<p class='title'>Automate your billing process by connecting Tripletex to Uku.</p> <div class='body-2'><p>Benefits of the Tripletex integration:</p><ul><li>Import all your clients from Tripletex to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "\"Uku\" importuos visus klientus, klientų informaciją ir klasifikatorius iš \"Tripletex\". Paskutiniame žingsnyje galite pasirinkti, kuriuos klientus norite pridėti arba atnaujinti.",
    "Connect Tripletex": "Prijunkite \"Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Prieš importuodami klientus turite prijungti \"Uku\" ir \"Tripletex\" programinę įrangą. Norėdami tai padaryti, sukurkite darbuotojo simbolį ir įveskite jį čia.",
    "Get employee token": "Gauti darbuotojo simbolį",
    "Insert employee token": "Įterpti darbuotojo simbolį",
    "Install": "Diegti",
    "Open Chrome browser to install": "Norėdami įdiegti, atidarykite „Chrome“ naršyklę",
    "Works with your online accounting software.": "Veikia su jūsų internetine apskaitos programine įranga.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Naujos užduotys gali užgriūti kaip griaustinis iš giedro dangaus, štai todėl „Mini „Uku\"\" yra jūsų geriausias draugas. Nesvarbu, ar darote bankinius pavedimus, ar dirbate su savo apskaitos programa, su „Mini „Uku\"\" galėsite pridėti naujas užduotis, stebėti laiką ir stebėti visus pranešimus iš bet kurio internetinio puslapio. <br><br>Vos vienas spustelėjimas ant pelėdos ikonėlės ir galėsite matyti visos dienos darbus, o tai padės jums planuoti savo darbotvarkę kur kas efektyviau.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "<p class='title'>Importuokite klientus ir darbo apimtis vienai ataskaitai su visų klientų atlikto darbo duomenimis gauti.</p><div class='body-2'><p>Duomenų rinkimą paspartinkite ir patikslinkite naudodami „Merit Aktiva“ ir „Uku“ integraciją. „Uku“ automatiškai importuoja kiekvieno kliento pardavimo ir pirkimo sąskaitas faktūras, dokumentus, įrašus ir t. t. ir vienoje interaktyvioje ataskaitoje pateikia darbo apimtis bei laiko įrašus. Daugiau nebereikės apskaitos programoje perjunginėti klientų ieškant informacijos apie dokumentus, apdorotus sąskaitoms faktūroms sukurti, arba stebėti kliento veiklos rezultatų. Palyginti su „Merit“, „Uku“ importuoja faktinę praėjusio mėnesio įrašų sumą atsižvelgdama į visus pakeitimus, kurie buvo įterpti ankstesniais laikotarpiais. Tai reiškia, kad jums nereikės prisiminti ar užsirašyti atliktų pakeitimų – „Uku“ turi visą šią informaciją ir jūs taip pat. Automatizuotas duomenų rinkimas taupo jūsų laiką ir pašalina žmogiškų klaidų tikimybę.</p><p>„Uku“ ir „Merit Aktiva“ integracija padeda:</p><p><ul><li>Greitai ir tiksliai surinkti duomenis – darbo apimtis į „Uku“ iš „Merit“ importuojama automatiškai</li><li>Analizuoti darbo krūvį ir laiką, turint išsamią atliktų darbų ir klientams skirto laiko apžvalgą</li><li>Automatizuoti mėnesio suvestinių kūrimą </li><li>Kiekvieną mėnesį apžvelgti faktinį darbo krūvį</li></ul></p><p>Naudodami „Uku“ ir „Merit“ integraciją galite importuoti:</p><p><ul><li>Dokumentus</li><li>Įrašus</li><li>Pardavimo sąskaitas faktūras</li><li>Pirkimo sąskaitas faktūras</li><li>Banko įrašus</li><li>Grynųjų pinigų įrašus</li><li>PVM įrašus</li><li>Atsargų įrašus</li><li>Ir t. t.</li></ul></p></div>",
    "Import clients": "Importuoti klientus",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Prijunkite esamą dokumentų valdymo sistemą",
    "Main folder": "Pagrindinis aplankas",
    "Under this folder, Uku automatically creates folders for each client.": "Šiame aplanke \"Uku\" automatiškai sukuria aplankus kiekvienam klientui.",
    "You can customize each client folder separately under client settings.": "Kiekvieną kliento aplanką galite pritaikyti atskirai, pasirinkę kliento nustatymus.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatiškai sukurti viešąjį aplanką klientų failams ir privatų aplanką narių failams",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatiškai sukurti Metų / mėnesio poaplankį po kiekvienu klientu failų rūšiavimui",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatiškai sukurti pastabų ir šablonų pakatalogius po kiekvienu klientu, kad būtų galima rūšiuoti failus",
    "Add task files added by Members": "Pridėti užduočių failus, kuriuos pridėjo nariai",
    "Add task files added by Clients (from emails and client portal)": "Pridėti klientų pridėtus užduočių failus (iš el. laiškų ir klientų portalo)",
    "Backup files to Uku file storage": "Atsarginių kopijų failų kūrimas į \"Uku\" failų saugyklą",
    "Perfect example": "Puikus pavyzdys",
    "You are about to disconnect this service.": "Ruošiamasi atjungti šią paslaugą.",
    "Google Drive": "Google Drive",
    "OneDrive": "\"OneDrive\"",
    "Select folder": "Pasirinkti aplanką",
    "Manage": "Valdymas",
    "Refresh": "Atnaujinti",
    "Be aware of the issues before they become problems": "Sužinokite apie sunkumus, kol jie netapo problemomis",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Kliento sutarties ir faktiškai atliktų darbų palyginimas realiu laiku;</li><li>Sužinokite apie sunkumus, kol jie netapo problemomis;</li><li>Net ir esant fiksuotoms kainoms, reikia turėti vidinius matavimus. Stebėkite kliento sutarties galiojimą, lygindami ją su faktiškai atliktų darbų kiekiu.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "prekės ženklo dizainas",
    "Subdomain": "Subdomenas",
    "Default language": "Numatytoji kalba",
    "Client portal URL in other languages": "Kliento portalo URL kitomis kalbomis",
    "Copy URL": "Kopijuoti URL",
    "Trademark": "prekės ženklas",
    "Trademark text color": "Prekės ženklo teksto spalva",
    "Choose color": "Pasirinkite spalvą",
    "Brand background color": "Prekės ženklo fono spalva",
    "Logo": "Logotipas",
    "Delete logo": "Ištrinti logotipą",
    "Upload logo file": "Įkelti logotipo failą",
    "Max. dimensions 180 x 60 px": "Maks. matmenys 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Ištrynimo piktograma",
    "Upload icon file": "Įkelti piktogramos failą",
    "Recommended size 260 x 260 px": "Rekomenduojamas dydis 260 x 260 px",
    "Company description": "Įmonės aprašymas",
    "Displayed on the login page.": "Rodoma prisijungimo puslapyje.",
    "Describe here what services you offer and how you help your clients.": "Aprašykite, kokias paslaugas siūlote ir kaip padedate klientams.",
    "Welcome video": "Pasveikinimo vaizdo įrašas",
    "Displayed on the login page when your client contact enters for the first time": "Rodoma prisijungimo puslapyje, kai jūsų kontaktinis asmuo įeina pirmą kartą",
    "Use Uku video": "Naudoti Uku vaizdo įrašą",
    "View": "Peržiūrėti",
    "Use other video": "Naudokite kitus vaizdo įrašus",
    "Youtube or Vimeo video URL": "\"Youtube\" arba \"Vimeo\" vaizdo įrašo URL",
    "Show file upload box for client tasks": "Rodyti failų įkėlimo langelį, kai atliekamos kliento užduotys",
    "Invalid data": "Neteisingi duomenys",
    "Client portal preview": "Klientų portalo peržiūra",
    "Client portal URL for {0} copied to clipboard": "Į iškarpinę nukopijuotas {0} kliento portalo URL adresas",
    "Personalize your client portal's menu": "Personalizuokite klientų portalo meniu",
    "Menu links saved": "Išsaugotos meniu nuorodos",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Pridėkite pasirinktines nuorodas į svarbiausius elementus, pvz: Dokumentus, finansines ataskaitas, įdarbinimo formas, grįžtamojo ryšio apklausas, paslaugų sutartis, kainas, instrukcijas, sąskaitas faktūras. Šiame skirsnyje galite sukurti meniu struktūrą, nustatyti elementų tvarką ir apibrėžti numatytuosius saitus. Taip pat galite pritaikyti pavadinimus ir nuorodas kiekvienam klientui atskirai. Klientų portale rodomi tik meniu su nustatytomis nuorodomis. <a href='/api/help_link/cp_menu_links' target='_blank'>Skaityti daugiau</a>",
    "Menu links": "Meniu nuorodos",
    "Add recurring task": "Pridėti pasikartojančią užduotį",
    "Reminder tasks updated": "Atnaujintos priminimo užduotys",
    "Create recurring tasks for Companies House clients.": "Kurkite pasikartojančias užduotis \"Companies House\" klientams.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "mygtukai",
    "Show to me": "Rodyti man",
    "magic_button_app_overview_text": "<p class='title'>Vienu spustelėjimu pridėkite naują užduotį ir paleiskite laikmatį.</p> <div class='body-2'><p>Magiški mygtukai leidžia patogiai įterpti skubią užduotį (telefono skambutį, el. laišką).</p><p>Nedelsdiant įterpkite visas užduotis į „Uku“</p><p>Magiški mygtukai leidžia patogiai įterpti skubias užduotis (telefono skambutį, el. laišką) į „Uku“. Taip užtikrinama, kad užduotys būtų tinkamai įterptos į „Uku“.</p><p>Apie magiškus mygtukus:</p><ul><li>Įterpkite naują užduotį ir vienu spustelėjimu paleiskite laikmatį (perkelkite į „+“ mygtuką viršutinėje juostoje).</li><li>Pritaikykite magiškus mygtukus pagal savo poreikius.</li><li>Vėliau pakeiskite kliento ar kitą informaciją.</li><li>Tęskite ankstesnę užduotį, kurią galite greitai pasiekti iš stebuklingųjų mygtukų sąrašo.</li></ul></div>",
    "Buttons": "Mygtukai",
    "Member rights": "Narių teisės",
    "Allow managers to view and create their client contracts and invoices": "Leisti vadybininkams peržiūrėti ir sukurti jų klientų sutartis ir sąskaitas faktūras",
    "Allow members to view and create their client invoices": "Leisti nariams peržiūrėti ir sukurti jų klientų sutartis ir sąskaitas faktūras",
    "Allow members to view their client invoices": "Leisti nariams peržiūrėti jų klientų sąskaitas faktūras",
    "Allow only owners to add and update products": "Pridėti ir atnaujinti produktus leisti tik savininkams",
    "Allow members to send invoices to clients": "Leisti nariams siųsti sąskaitas faktūras klientams",
    "Allow members to confirm their client invoice rows": "Leisti nariams patvirtinti jų klientų sąskaitų faktūrų eilutes",
    "Send PDF invoice": "Siųsti PDF sąskaitą faktūrą",
    "Invoice email": "Sąskaitos faktūros el. paštas",
    "Default rounding": "Numatytasis apvalinimas",
    "Round all times up to x": "Suapvalinkite visus laikus iki x",
    "Time rounding increment": "Laiko apvalinimo prieaugis",
    "Apply time rounding to": "Taikyti laiko apvalinimą",
    "Default configuration": "Numatytoji konfigūracija",
    "Invoice date": "Sąskaitos data",
    "Invoice entry date": "Sąskaitos faktūros įtraukimo data",
    "Bill tracked time by": "Billas stebėjo laiką pagal",
    "Bill task field by": "Sąskaitos užduoties laukas pagal",
    "Create one invoice merging invoices from the same period": "Sukurti vieną sąskaitą faktūrą, sujungiant to paties laikotarpio sąskaitas faktūras",
    "Invoices from the same period": "To paties laikotarpio sąskaitos faktūros",
    "Hide zero sum lines": "Paslėpti nulinės sumos eilutes",
    "By default, time entry is billable": "Pagal numatytuosius nustatymus, laiko įrašai yra mokami",
    "Invoice number": "Sąskaitos faktūros numeris",
    "Prefix": "Priešdėlis",
    "Suffix": "Priesaga",
    "Google Gmail": "„Google Gmail\"",
    "Microsoft Outlook": "„Microsoft Outlook\"",
    "Billing settings saved": "Sąskaitos išrašymo informacija išsaugota",
    "billing_app_overview_text": "<p class='title'>Pagreitinkite sąskaitų klientams išrašymo procesą naudodami lanksčius kainoraščius ir išmaniąsias sutartis.</p><div class='body-2'><p>Automatizuokite sąskaitų faktūrų išrašymo procesą ir nešvaistykite savo brangaus laiko sąskaitoms faktūroms generuoti. „Uku“ dinaminis sąskaitų išrašymas sukuria visas jūsų sąskaitas faktūras pagal atliktą darbą ir padeda jums uždirbti sąžiningą pelną iš klientų. Daugiau nebereiks rinkti duomenų iš skirtingų programų ar „Excel“ lentelių – „Uku“ turi viską ir parengia sąskaitas faktūras už jus. Jums belieka tik peržiūrėti sąskaitas faktūras ir jas išsiųsti.</p><p>„Uku“ sąskaitų išrašymas:</p><p><ul><li><b>Sutaupoma laiko,</b> nes sutrumpėja administracinio darbo valandos</li><li><b>Didina pajamas</b> – sąskaitos faktūros išrašomos pagal visus atliktus darbus</li><li><b>Sumažina klaidų skaičių / padeda išvengti</b> neteisingų sąskaitų faktūrų išrašymo kiek įmanoma sumažinant žmogaus įsikišimą</li><li><b>Užtikrina pastovų pajamų srautą</b>, nes sąskaitos išrašomos laiku</li><li><b>Didina skaidrumą</b> dėl išsamių ir lengvai prieinamų sutarčių su klientais</li><li><b>Padidina tikslumą,</b> nes registruojami visi sutarčių pakeitimai nuo pirmos dienos</li><li><b>Suteikia lankstumo, pritaikomumo</b> verslo augimui ir užtikrina geresnę klientų patirtį</li></ul></p><p>„Uku“ palaiko įvairius kainodaros modelius – kad ir kokius susitarimus būtumėte sudarę su klientais, mes jums padėsime. „Uku“ sąskaitų faktūrų išrašymas leidžia kurti produktus, įskaitant:</p><p><ul><li>Valandų kainodarą (pvz., buhalterio kaina, asistento kaina)</li><li>Fiksuoto užmokesčio kainodarą (pvz., paketai, metinė sutartinė kaina)</li><li>Verte pagrįstą kainodarą (pvz., suvokiama paslaugų vertė)</li><li>Darbo apimtimi pagrįstą kainodarą (pvz., apdorotų dokumentų kiekis)</li><li>Papildomų paslaugų kainas (pvz., metinės ataskaitos, konsultacijos)</li><li>Kelių modelių derinius (pvz., fiksuoto mokesčio kainodara + papildomai dirbtos valandos; darbo apimtis + konsultacijų valandos; ir t. t.)</li></ul></p><p>Su „Uku“ sukūrę sąskaitas faktūras, galite jas peržiūrėti, padaryti pakeitimus (jei reikia) ir išsiųsti visas iš karto.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Sužinokite daugiau apie „Uku“ sąskaitų išrašymą čia.</a> </p><p>Jei norite įdiegti „Uku“ sąskaitų išrašymą ir norėtumėte pasikonsultuoti su mūsų ekspertu, <a href='https://calendly.com/getuku/uku-billing' target='_blank'>rezervuokite laiką </a> (nemokamai) čia.</p></div>",
    "Products": "Produktai",
    "Contract templates": "Sutarčių šablonai",
    "Invoice templates": "Sąskaitų faktūrų šablonai",
    "Tools": "Įrankiai",
    "Replace tax": "Pakeisti mokestį",
    "Old tax": "Senieji mokesčiai",
    "New tax": "Naujas mokestis",
    "Find tax": "Ieškoti mokesčių",
    "Replace VAT in products": "Pakeisti PVM produktams",
    "Replace VAT in master contracts": "Pakeiskite PVM sutarčių šablonuose",
    "Replace VAT in client contracts & draft invoices": "Pakeiskite PVM klientų sutartyse ir sąskaitų faktūrų projektuose",
    "Replace VAT values": "Pakeiskite PVM vertes",
    "This action cannot be undone": "Šio veiksmo anuliuoti negalima",
    "Replace": "Pakeisti",
    "Result": "Rezultatas",
    "PDF templates": "PDF šablonai",
    "E-mail templates": "El. laiškų šablonai",
    "Edit PDF template": "Redaguoti PDF šabloną",
    "Import classificators": "Importavimo klasifikatoriai",
    "products": "produktai",
    "product": "produktas",
    "Product / service": "Produktas / paslauga",
    "Calculate": "Skaičiuoti",
    "Article": "Straipsnis",
    "Resource": "Ištekliai",
    "Cost center": "Išlaidų centras",
    "Taxes": "Mokesčiai",
    "Code": "Kodas",
    "Source": "Šaltinis",
    "Articles": "Straipsniai",
    "Resources": "Ištekliai",
    "Cost centers": "Išlaidų centrai",
    "Units": "Vnt.",
    "Unit": "Vienetas",
    "Bank accounts": "Bankų saskaitos",
    "Bank account": "Banko sąskaita",
    "Bank name": "Banko pavadinimas",
    "IBAN": "IBAN",
    "SWIFT code": "SWIFT kodas",
    "Do you wish to import only new data or also overwrite existing?": "Ar norite importuoti tik naujus duomenis, ar ir perrašyti esamus?",
    "Only new": "Tik nauji",
    "New items will be added. Existing ones will remain unchanged by import.": "Bus pridėta naujų elementų. Esamos prekės liks nepakeistos importuojant.",
    "Import everything": "Importuokite viską",
    "Connect accounting service": "Prijungti apskaitos paslaugą",
    "Service": "Paslauga",
    "API ID": "API ID",
    "API key": "API raktas",
    "Company Account Id": "Įmonės sąskaitos ID",
    "Api secret": "Api slaptas",
    "E-conomic": "„E-conomic“",
    "SmartAccounts": "„SmartAccounts“",
    "Test": "Bandymas",
    "Lock time entries": "Užrakinti laiko įrašus",
    "Owner rights": "Savininko teisės",
    "Disable company settings edit for all members": "Išjungti įmonės nustatymų redagavimą visiems nariams",
    "Disable personal clients for members": "Asmeninių klientų išjungimas nariams",
    "Show member birthdays": "Rodyti narių gimtadienius",
    "Show contact birthdays": "Rodyti kontaktų gimtadienius",
    "Weekly @ Sun {0}": "Kas savaitę, sekmadienį {0}",
    "Monthly @ last day of month": "Kas mėnesį paskutinę mėnesio dieną",
    "Company event list": "Įmonės renginių sąrašas",
    "How long?": "Kiek laiko?",
    "Invoice no.": "PVM sąskaitos faktūros nr.",
    "Login options": "Prisijungimo būdai",
    "Tenant ID (optional)": "Nuomininko ID (neprivaloma)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Pridėti „Active Directory“ nuomininko ID, jei prisijungti leidžiama tik šio nuomininko vartotojams",
    "How to find ID’s?": "Kaip rasti ID?",
    "Microsoft connected": "„Microsoft“ prijungta",
    "Google connected": "„Google“ prijungta",
    "Edit company": "Redaguoti įmonę",
    "Timezone": "Laiko juosta",
    "VAT number": "PVM kodas",
    "Company number": "Įmonės kodas",
    "Subscription plan": "Prenumeratos planas",
    "Payment failed": "Mokėjimas nepavyko",
    "Retry payment": "Bandykite dar kartą sumokėti",
    "Next payment": "Kitas mokėjimas",
    "Update payment method": "Atnaujinti mokėjimo metodą",
    "Plan": "Planas",
    "Choose a plan": "Pasirinkti planą",
    "Change plan": "Keisti planą",
    "{0}-day free trial until {1}": "{0} - dienos nemokamas bandomasis laikotarpis iki {1}",
    "monthly": "kas mėnesį",
    "yearly": "kasmet",
    "{0} member": "{0} narys",
    "{0} members": "{0} nariai",
    "{0} plan": "{0} planą",
    "Cancelled (valid until {0})": "Atšaukta (galioja iki {0})",
    "Your trial expired on {0}": "Bandomosios versijos galiojimo laikas baigėsi {0}",
    "Your subscription expired on {0}": "Jūsų prenumerata baigėsi {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Malonu jus matyti! Jei norite pradėti naudotis \"Uku\" prenumerata, spustelėkite Pasirinkti planą",
    "Save {0} by paying for a year!": "Sutaupykite {0} mokėdami už metus!",
    "Choose plan": "Pasirinkti planą",
    "Pay annually": "Mokėti kasmet",
    "Instructions sent!": "Nurodymai išsiųsti!",
    "Instructions for resetting your password have been sent to": "Nurodymai, kaip iš naujo nustatyti slaptažodį, išsiųsti adresu",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Šį laišką gausite per 5 minutes. Nepamirškite patikrinti šlamšto aplanko.",
    "Back to login page": "Grįžti į prisijungimo puslapį",
    "Get new password": "Gauti naują slaptažodį",
    "Pick a password": "Pasirinkti slaptažodį",
    "Use minimum 8 characters with letters & numbers": "Naudokite mažiausiai 8 simbolius su raidėmis ir skaičiais",
    "Create your Uku Account": "Sukurkite savo „„Uku\"“ paskyrą",
    "Connect your Xero Account": "Susiekite savo Xero paskyrą",
    "Phone": "Telefonas",
    "I agree to the": "aš sutinku su",
    "Terms of Service": "Paslaugų teikimo sąlygos",
    "Next": "Toliau",
    "Having trouble?": "Turite problemų?",
    "We can help": "Mes galime padėti",
    "Log in instead": "Vietoj to prisijunkite",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Nr.1 apskaitos darbų įrankis. Automatizuotos darbo eigos, laiko sekimas, ataskaitos, stebėjimas, CRM. Atlikite darbus laiku ir pelningai. Išbandykite nemokamai!",
    "You are invited to join": "Esate pakviesti prisijungti",
    "Accept invitation": "Priimti kvietimą",
    "Check your email": "Patikrinkite savo paštą",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Aš išsiunčiau jums el. laišką su nuoroda, kad suaktyvintumėte savo paskyrą. Tai svarbu norint užtikrinti paskyros saugumą.",
    "Go to": "Eiti į",
    "Need a new password?": "Reikia naujo slaptažodžio?",
    "Enter your e-mail address and we will send you directions for changing your password": "Įveskite savo el. pašto adresą ir mes atsiųsime jums nurodymus, kaip pakeisti slaptažodį",
    "Send me instructions": "Atsiųskite man instrukcijas",
    "Never mind, go back": "Nesvarbu, grįžti atgal",
    "No login options enabled. Please contact the company owner": "Nėra įjungtų prisijungimo parinkčių. Susisiekite su įmonės savininku",
    "Log in to Uku": "Prisijunkite prie „„Uku\"\"",
    "Forgot password?": "Pamiršote slaptažodį?",
    "Don't have account?": "Neturite paskyros?",
    "Create account": "Sukurti paskyrą",
    "Total items:": "Viso vienetų:",
    "Add new": "Pridėti naują",
    "Amount": "Suma",
    "Account created range": "Paskyros sukurtas diapazonas",
    "Usage limit": "Naudojimo apribojimas",
    "Valid until": "Galioja iki",
    "Edit help link": "Redaguoti pagalbos nuorodą",
    "New help link": "Nauja pagalbos nuoroda",
    "Name key": "Pavadinimo raktas",
    "Country code": "Šalies kodas",
    "Period (months)": "Laikotarpis (mėnesiais)",
    "Account created from": "Paskyra sukurta nuo",
    "Account created until": "Paskyra sukurta iki",
    "Used count": "Naudotas skaičius",
    "Sum": "Suma",
    "Create voucher": "Sukurti kuponą",
    "Edit voucher": "Redaguoti kuponą",
    "Are you sure to delete this voucher?": "Ar tikrai norite ištrinti šį kuponą?",
    "row | rows": "eilutė | eilutės",
    "Add event": "Pridėti įvykį",
    "Are you sure you wish to delete this event?": "Ar tikrai norite ištrinti šį įvykį?",
    "event | events": "įvykis | įvykiai",
    "Security object id": "Apsaugos objekto ID",
    "Direct rights": "Tiesioginės teisės",
    "Computed rights": "Apskaičiuotos teisės",
    "Add link": "Pridėti nuorodą",
    "Are you sure you wish to delete this entry?": "Ar tikrai norite ištrinti šį įrašą?",
    "link | links": "nuoroda | nuorodos",
    "Event type": "Įvykio tipas",
    "Date from": "Data nuo",
    "Date until": "Data iki",
    "Shortened by h": "Sutrumpėjo h",
    "Category": "Kategorija",
    "demo | demos": "demo | demo",
    "Companies": "Įmonės",
    "Leads": "Potencialus klientai",
    "Demos": "Demonstracijos",
    "Vouchers": "Kuponai",
    "KPI": "KPI",
    "Activity log": "Veiklos žurnalas",
    "Notifications": "Pranešimai",
    "Me": "Aš",
    "Important notifications will appear here.": "Čia bus rodomi svarbūs pranešimai.",
    "Back": "Atgal",
    "Return to UKU": "Grįžti į „Uku\"",
    "Choose plan for {0}": "Pasirinkite planą {0}",
    "First payment will be made after the end of the trial period.": "Pirmą mokėjimą reikės atlikti pasibaigus bandomajam laikotarpiui.",
    "Members and subscription can always be changed.": "Narius ir prenumeratas galima bet kada pakeisti.",
    "Your subscription is externally managed by Xero": "Jūsų prenumeratą išoriškai valdo \"Xero\"",
    "Select plan": "Pasirinkite planą",
    "Billing period": "Atsiskaitymo periodas",
    "Compare features": "Palyginti savybes",
    "Cancel uku subscription": "Atšaukti „Uku\" prenumeratą",
    "{0} discount": "{0} nuolaida",
    "You have currently<br />{0} active member": "Šiuo metu turite<br />{0} aktyvių vartotojų",
    "You have currently<br />{0} active members": "Šiuo metu turite<br />{0} aktyvių vartotojų",
    "Select yearly plan": "Pasirinkite metinį planą",
    "Select monthly plan": "Pasirinkite mėnesio planą",
    "Attention!": "Dėmesio!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Jei norite naudotis „Uku\" nemokamai, deaktyvuokite savo paskyrą ir tęskite naudojimą „{0\"} planu",
    "per member/month (billed yearly)": "nariui/mėnesiui (atsiskaitymas kas metus)",
    "or {0} per member/month (monthly)": "arba {0} nariui/mėnesiui (kas mėnesį)",
    "Everything in {0}, plus:": "Viskas, kaip „{0}\", plius:",
    "Compare plans, feature-by-feature": "Palyginti planus pagal funkcijas",
    "Deactivate account": "Deaktyvuoti paskyrą",
    "Are you sure to deactivate {0} account?": "Ar tikrai norite deaktyvuoti {0} paskyrą?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Jei nuspręsite naudotis „Freelancer\" planu, jūsų įmonės paskyra bus deaktyvuota. Su šia įmone susiję duomenys bus pašalinti.",
    "Deactivate": "Deaktyvuoti",
    "Teamwork": "Komandinis darbas",
    "Unlimited clients + import": "Neriboti klientai + importavimas",
    "Access management": "Prieigos valdymas",
    "Custom fields": "Pritaikyti laukeliai",
    "Live chat support": "Pagalba per pokalbių programą",
    "AML": "Pinigų plovimo prevencija",
    "API": "API",
    "Client Portal": "Klientų portalas",
    "New!": "Nauja!",
    "Custom integrations": "Pasirinktos integracijos",
    "Assisted clients import": "Pagalba importuojant klientus",
    "Tailor-made team workshop": "Specialiai jums pritaikyta komandos darbo grupė",
    "Early access to features": "Ankstyva prieiga prie funkcijų",
    "Pay by invoice": "Apmokėti pagal sąskaitą faktūrą",
    "Dedicated account manager": "Priskirtas vadybininkas",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Labas! Jūsų bandomoji versija baigėsi. Jei norite tęsti darbus, pasirinkite „{0}\" prenumeratos planą.",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Labas! Jei norite toliau naudotis šia funkcija, privalote įsigyti „{0}\" prenumeratos planą.",
    "Waiting for the subscription to complete": "Laukiama, kol bus baigta prenumerata",
    "Edit VAT number": "Redaguoti PVM mokėtojo kodą",
    "VAT": "PVM",
    "This is subscription period amount.": "Tai prenumeratos laikotarpio suma.",
    "You save yearly {0}": "Sutaupote kasmet {0}",
    "Add voucher": "Pridėti kuponą",
    "Existing credit": "Esamas kreditas",
    "Current payment": "Einamasis mokėjimas",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Tai dabartinė mokėjimo suma. Jūsų bankas taip pat reikalauja patvirtinti prenumeratos laikotarpio sumą.",
    "Confirm subscription {0}": "Patvirtinti prenumeratą {0}",
    "Your subscription will renew on": "Jūsų prenumerata bus atnaujinta",
    "Thank you for believing in us!": "Dėkojame, kad mumis tikite!",
    "Uku team": "Uku komanda",
    "Voucher {1} (-{0}%)": "Kuponas {1} (-{0}%)",
    "Voucher {0}": "Kuponas {0}",
    "New plan": "Naujas planas",
    "Changed plan": "Pakeistas planas",
    "Add {0} member": "Pridėti {0} narį",
    "Add {0} members": "Pridėti {0} narių",
    "Remove {0} member": "Pašalinti {0} narį",
    "Remove {0} members": "Pašalinti {0} narių",
    "No changes to plan": "Planas nekeičiamas",
    "Discount -{0}% with Yearly subscription": "Nuolaida - {0}% pasirinkus metinę prenumeratą",
    "Yearly discounted price (-{0}%)": "Metinė diskontuota kaina (-{0}%)",
    "Subscription updated": "Prenumerata atnaujinta",
    "Please wait": "Prašau palaukti",
    "Your payment failed": "Nepavyko sumokėti",
    "Please check that you entered the data correctly or use another card": "Patikrinkite, ar teisingai įvedėte duomenis, arba naudokite kitą kortelę",
    "Try again": "Bandykite iš naujo",
    "Pay": "Mokėti",
    "Payment": "Apmokėjimas",
    "Payment method updated": "Atnaujintas mokėjimo būdas",
    "Edit member": "Redaguoti narį",
    "First name": "Vardas",
    "Last name": "Pavardė",
    "External ID": "Išorinis ID",
    "Select groups": "Pasirinkite grupes",
    "Administrator": "Administratorius",
    "Invite sent": "Išsiųstas kvietimas",
    "Activate member": "Suaktyvinti narį",
    "Deactivate member": "Išjungti narį",
    "Invited": "Pakviestas",
    "Paid member": "Mokamas narys",
    "Send an invitation": "Siųsti kvietimą",
    "Limited": "Ribotas",
    "No invite, no access": "Nėra kvietimo, nėra prieigos",
    "Free until activated": "Nemokama, kol aktyvuojama",
    "No access, no charge": "Nėra prieigos, nėra mokesčio",
    "Hidden member": "Paslėptas narys",
    "Edit members": "Redaguoti narius",
    "Select user": "Pasirinkite vartotoją",
    "Member will be assigned to every selected client": "Kiekvienam pasirinktam klientui bus priskirtas narys",
    "Member will be removed from all selected clients": "Narys bus pašalintas nuo visų pasirinktų klientų",
    "Assign user": "Priskirti vartotoją",
    "Set as primary user": "Nustatyti kaip pagrindinį vartotoją",
    "Added as a default user when adding a task plan": "Pridėtas kaip numatytasis vartotojas, kai pridedamas užduočių planas",
    "Remove from new tasks": "Pašalinti iš naujų užduočių",
    "Remove from plan tasks": "Pašalinti iš plano užduočių",
    "Remove": "Pašalinti",
    "Admin": "Administratorius",
    "Remove user": "Pašalinti vartotoją",
    "Assign to incomplete tasks": "Priskirkite nebaigtas užduotis",
    "Reassign incomplete tasks": "Priskirkite neužbaigtas užduotis iš naujo",
    "Assign to plan tasks": "Priskirti prie plano užduočių",
    "Reassign plan tasks": "Priskirti plano užduotis iš naujo",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Savininkas bus priskirtas užduotims, jei pašalintas vartotojas buvo paskutinis priskirtas vartotojas.",
    "Run integration": "Vykdyti integraciją",
    "Run": "Paleisti",
    "Integration configuration": "Integracijos konfigūracija",
    "Read the manual": "Perskaitykite vadovą",
    "Api key": "Api raktas",
    "Are you sure to delete this integration info?": "Ar tikrai norite ištrinti šią integracijos informaciją?",
    "Edit Contracts": "Redaguoti sutartis",
    "Replace following contracts": "Pakeisti sekančias sutartis",
    "Append services to following contracts": "Pridėti paslaugas prie sekančių sutarčių",
    "Choose template": "Pasirinkti šabloną",
    "Append only": "Tik pridėti",
    "with template": "su šablonu",
    "All existing contracts": "Visos esamos sutartys",
    "All quarterly contracts": "Visos ketvirtinės sutartys",
    "All monthly contracts": "Visos mėnesinės sutartys",
    "All yearly contracts": "Visos metinės sutartys",
    "Next invoice number": "Kitos sąskaitos faktūros numeris",
    "Number is too big, it cannot exceed 15 digits": "Numeris per ilgas, jis negali viršyti 15 skaičių",
    "Replace topic": "Pakeisti temą",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Visos užduotys ir planai su dabartine tema bus pakeisti nauja pasirinkta tema.",
    "Topics replaced": "Pakeistos temos",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Visos užduotys, kurių tema yra „{0}“, bus pakeistos su „{1}“. Tai nėra grįžtama. Ar tikrai norite pakeisti?",
    "Name of topic": "Temos pavadinimas",
    "Change topic": "Keisti temą",
    "Add new topic": "Pridėti naują temą",
    "This topic is in use. Do you wish to archive it?": "Ši tema yra naudojama. Ar norite ją suarchyvuoti?",
    "Are you sure that you want to delete this topic?": "Ar tikrai norite ištrinti šią temą?",
    "These items will be deleted permanently": "Šie elementai bus ištrinti visam laikui",
    "Are you sure that you want to delete this client group?": "Ar tikrai norite ištrinti šią klientų grupę?",
    "This client group is in use. Do you wish to archive it?": "Ši klientų grupė naudojama. Ar tikrai norite ją archyvuoti?",
    "Edit client group": "Redaguoti klientų grupę",
    "New client group": "Nauja klientų grupė",
    "Price": "Kaina",
    "Quantity": "Kiekis",
    "Unit will be translated to client language": "Vienetas bus išverstas į kliento kalbą",
    "Pick date & time": "Pasirinkite datą ir laiką",
    "Share equally": "Dalytis vienodai",
    "Change existing": "Keisti esamą",
    "Choose bookmark": "Pasirinkite žymę",
    "New title": "Naujas pavadinimas",
    "Set as my default view": "Nustatyti kaip mano numatytąjį vaizdą",
    "Signature name": "Parašo pavadinimas",
    "Layout": "Išdėstymas",
    "Top": "Viršus",
    "Middle": "Viduryje",
    "Bottom": "Apačia",
    "Default signature": "Numatytasis parašas",
    "Max. dimensions 130 x 130 px": "Maksimalūs matmenys 130 x 130 px",
    "Logo left": "Kairysis logotipas",
    "Logo top": "Logotipas viršuje",
    "No logo": "Logotipo nėra",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "El. pašto parašas",
    "Edit email signature": "Redaguoti el. pašto parašą",
    "Add email signature": "Pridėti el. pašto parašą",
    "Font color": "Šrifto spalva",
    "Actions": "Veiksmai",
    "Delete signature": "Ištrinti parašą",
    "Do you wish to update related contracts and invoices?": "Ar norite atnaujinti susijusias sutartis ir sąskaitas faktūras?",
    "Update contract templates, active contracts and open invoices.": "Atnaujinkite sutarčių šablonus, aktyvias sutartis ir atviras sąskaitas faktūras.",
    "The following fields will be updated": "Šie laukai bus atnaujinti",
    "Custom Value": "Pritaikyta vertė",
    "This product is in use. Do you wish to archive it?": "Šis produktas yra naudojamas. Ar norite jį suarchyvuoti?",
    "Are you sure that you want to delete this product?": "Ar tikrai norite ištrinti šį produktą?",
    "Customize for client": "Tinkinti klientui",
    "Customize for template": "Tinkinti pagal šabloną",
    "Open product template": "Atidaryti produkto šabloną",
    "Create product template": "Sukurkite produkto šabloną",
    "Master template": "Pagrindinis šablonas",
    "Client product": "Kliento produktas",
    "Client product / service": "Kliento produktas / paslauga",
    "New client product": "Naujas kliento produktas",
    "Template product": "Šablonas produktas",
    "Template product / service": "Produkto / paslaugos šablonas",
    "New template product": "Naujas šabloninis produktas",
    "Edit translations": "Redaguoti vertimus",
    "Billable topics": "Apmokestinamos temos",
    "Billable time": "Apmokestinamas laikas",
    "Minimum quantity": "Minimalus kiekis",
    "Minimum time": "Minimalus laikas",
    "Integration parameters": "Integravimo parametrai",
    "Empty values will use product default": "Tuščios vertės naudos produkto numatytuosius nustatymus",
    "Pricing": "Kainodara",
    "DC %": "Nuol. %",
    "Sum all matching rows": "Sumuokite visas atitinkančias eilutes",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Kai ši funkcija įjungta, bendra kaina yra bendra visų sutampančių eilučių suma. Pagal numatytuosius nustatymus bendra kaina kaina naudoja tik didžiausią atitikimo eilutę.",
    "Prices since": "Kainos nuo",
    "Add price": "Pridėkite kainą",
    "Add pricing period": "Pridėti kainodaros laikotarpį",
    "Update contracts": "Atnaujinti sutartis",
    "(Without topic)": "(Be temos)",
    "Fixed price": "Fiksuota kaina",
    "Product": "Produktas",
    "Event created": "Sukurtas įvykis",
    "Project created": "Sukurtas projektas",
    "Event deleted": "Ištrintas įvykis",
    "Project deleted": "Išbrauktas projektas",
    "Workflow added": "Pridėta darbo eiga",
    "Workflow removed": "Pašalinta darbo eiga",
    "Workflow updated": "Atnaujinta darbo eiga",
    "Event cancelled": "Renginys atšauktas",
    "Project cancelled": "Projektas atšauktas",
    "Event reactivated": "Įvykis vėl aktyvuotas",
    "Project reactivated": "Atnaujintas projektas",
    "Event archived": "Renginys archyvuotas",
    "Project archived": "Projektas archyvuotas",
    "Event unarchived": "Įvykis nearchyvuotas",
    "Project unarchived": "Projektas nearchyvuotas",
    "Event changed": "Įvykis pasikeitė",
    "Project changed": "Pakeistas projektas",
    "Event status changed: {0}": "Įvykio būsena pasikeitė: {0}",
    "Project status changed: {0}": "Pakeista projekto būsena: {0}",
    "Event status changed": "Įvykio būsena pasikeitė",
    "Project status changed": "Pakeista projekto būsena",
    "Task created": "Užduotis sukurta",
    "Task changed": "Užduotis pakeista",
    "Task finished": "Užduotis baigta",
    "Task not finished": "Užduotis nebaigta",
    "Task deleted": "Užduotis ištrinta",
    "Add project": "Pridėti projektą",
    "Hide filters": "Slėpti filtrus",
    "Show filters": "Rodyti filtrus",
    "Cancel event": "Atšaukti įvykį",
    "Cancel project": "Atšaukti projektą",
    "Manage event fields": "Įvykio laukų tvarkymas",
    "Manage project fields": "Tvarkyti projekto laukus",
    "New event": "Naujas renginys",
    "New project": "Naujas projektas",
    "{0} (Copy)": "{0} (Kopijuoti)",
    "Are you sure you wish to delete this project?": "Ar tikrai norite ištrinti šį projektą?",
    "Are you sure to archive this event?": "Ar tikrai norite archyvuoti šį įvykį?",
    "Are you sure to archive this project?": "Ar tikrai norite suarchyvuoti šį projektą?",
    "Are you sure to cancel this event?": "Ar tikrai norite atšaukti šį renginį?",
    "Are you sure to cancel this project?": "Ar tikrai norite atšaukti šį projektą?",
    "Communication": "Komunikacija",
    "Log": "Žurnalas",
    "Create event workflow": "Sukurti įvykio darbo eigą",
    "Create project workflow": "Sukurti projekto darbo eigą",
    "Use workflow templates to set up tasks effectively or": "Naudokite darbo eigos šablonus, kad veiksmingai nustatytumėte užduotis arba",
    "Add tasks manually": "Pridėkite užduotis rankiniu būdu",
    "Save bookmark": "Išsaugoti žymę",
    "Remove filters": "Pašalinkite filtrus",
    "Filter": "Filtras",
    "Show multiselect": "Rodyti daugialypį pasirinkimą",
    "To do today": "Tai padaryti šiandien",
    "This and next month": "Šį ir kitą mėnesį",
    "Last 3 months": "Paskutiniai 3 mėnesiai",
    "Next 3 months": "Ateinantys 3 mėnesiai",
    "Starts": "Prasideda",
    "To do": "Padaryti",
    "today": "šiandien",
    "tomorrow": "rytoj",
    "yesterday": "vakar",
    "Previous week": "Praeita savaite",
    "Group similar tasks": "Grupuoti panašias užduotis",
    "Group by client": "Grupuoti pagal klientą",
    "Group by date": "Grupuoti pagal datą",
    "Group by topic": "Grupuoti pagal temą",
    "Your details": "Jūsų duomenys",
    "City": "Miestas",
    "Regional format": "Regioninis formatas",
    "Default company": "Numatytoji įmonė",
    "Lock time entries notification": "Pranešimas apie laiko įrašų užrakinimą",
    "Notify by": "Pranešti iki",
    "Delete my account": "Ištrinti mano paskyrą",
    "Attention": "Dėmesio",
    "Are you sure that you want to delete your account?": "Ar tikrai norite ištrinti savo paskyrą?",
    "Notification": "Pranešimu",
    "Notification & email": "Pranešimu ir el. laišku",
    "Vacations / absence": "Atostogos / neatvykimas",
    "Edit balance": "Redaguoti balansą",
    "View history": "Peržiūrėti istoriją",
    "Request": "Prašymas",
    "How long": "Kiek laiko?",
    "Requested": "Paprašyta",
    "Approved": "Patvirtinta",
    "Rejected": "Atmesta",
    "In review": "Peržiūrima",
    "Change": "Keisti",
    "Agreements": "Sutartys",
    "New agreement": "Nauja sutartis",
    "Change agreement": "Keisti sutartį",
    "Stop demo": "Sustabdyti demo versiją",
    "Show": "Rodyti",
    "Don't show": "Nerodyti",
    "Don't send": "Nesiųsti",
    "Email workdays at 7 AM": "Siųsti el. paštu darbo dienomis 7:00 val.",
    "Email at 3 PM": "Siųsti el. paštu 15:00",
    "Email at once": "Siųsti el. paštu iš karto",
    "Email Sundays at 11 PM": "Siųsti sekmadieniais 23:00",
    "First day of the month": "Pirmoji mėnesio diena",
    "to email": "elektroniniu paštu",
    "E-mail at once": "El. paštau iškart",
    "System": "Sistema",
    "Person": "Asmuo",
    "Picture": "Paveikslėlis",
    "Time zone": "Laiko zona",
    "Calendar settings": "Kalendoriaus nustatymai",
    "Public holidays": "Valstybinės šventės",
    "Tax deadlines": "Mokesčių terminai",
    "News": "Naujienos",
    "External services": "Išorinės paslaugos",
    "Google log in": "„Google“ prisijungimas",
    "Microsoft log in": "„Microsoft“ prisijungimas",
    "Are you sure to remove microsoft?": "Ar tikrai norite pašalinti „Microsoft“?",
    "Agreement": "Sutartis",
    "Active agreement": "Aktyvi sutartis",
    "Weekly hours": "Savaitės valandos",
    "Are you sure to remove google?": "Ar tikrai norite pašalinti „Google“?",
    "Edit supplier": "Redaguoti tiekėją",
    "New supplier": "Naujas tiekėjas",
    "Are you sure you wish to delete this supplier?": "Ar tikrai norite ištrinti šį tiekėją?",
    "Add supplier": "Pridėti tiekėją",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Tiekėjų tipai neapibrėžti. Eikite į tiekėjų programos nustatymus, norėdami juos pridėti.",
    "No members yet": "Kol kas nėra narių",
    "Edit group": "Redaguoti grupę",
    "Add group": "Pridėti grupę",
    "Are you sure to delete this user group?": "Ar tikrai norite ištrinti šią vartotojų grupę?",
    "Get set up to work with team": "Pasiruoškite dirbti su komanda",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Įmonės paskyra leidžia jums naudoti įrankius komandoms, gauti gilesnių įžvalgų ir pan. Kelkite savo komandos darbo eigos kokybę ir vadovaukite pelningesniam verslui.",
    "Create company account": "Sukurkite įmonės sąskaitą",
    "By creating a company account you activate Uku free subscription for {0} days.": "Susikurdami įmonės paskyrą jūs aktyvuojate nemokamą „„Uku\"\"prenumeratą {0} dienų.",
    "You have invited {0}/{1} members": "Pakvietėte {0}/{1} narių",
    "Upgrade": "Pagerinti",
    "Resend invite": "Pakartotinai išsiųsti kvietimą",
    "Send invite": "Siųsti kvietimą",
    "View profile": "Peržiūrėti profilį",
    "To add members to your team, you'll need to create a company account": "Norėdami į savo komandą pridėti narių, turėsite susikurti savo įmonės paskyrą",
    "Export": "Eksportuoti",
    "Re-invite sent": "Išsiųstas pakartotinis kvietimas",
    "View report": "Peržiūrėti ataskaitą",
    "Member {0} will be deactivated.": "Narys {0} bus išjungtas.",
    "Please select new member who will replace {0}.": "Pasirinkite naują narį, kuris pakeis {0}.",
    "Select new member": "Pasirinkti naują narį",
    "NB! Deactivation process cannot be reversed": "Svarbu! Išjungimo procesas negali būti atšauktas",
    "Magic button settings": "Stebuklingo mygtuko nustatymai",
    "Create only one task per month": "Sukurti tik vieną užduotį per mėnesį",
    "Current month's tasks": "Einamojo mėnesio užduotys",
    "extra work": "papildomas darbas",
    "Without topic": "Be temos",
    "Week": "Savaitė",
    "Previous month": "Praeitas mėnuo",
    "task | tasks": "užduotis | užduotys",
    "Assign to": "Priskirti",
    "Mark as done": "Pažymėti kaip atliktą",
    "Last": "Paskutinis",
    "Snooze": "Atidėti",
    "1 dependency": "1 priklausinys",
    "{0} dependencies": "{0} priklausiniai",
    "Client request": "Kliento prašymas",
    "Unread notification emails": "Neperskaityti pranešimų el. laiškai",
    "Unread internal comments": "Neskaityti vidiniai komentarai",
    "Add comment": "Pridėti komentarą",
    "Internal comment": "Vidinis komentaras",
    "Portal message": "Portalo žinutė",
    "Public message means that clients can read it and the client portal will notify them by email": "Viešas pranešimas reiškia, kad klientai gali jį perskaityti, o klientų portale jiems bus pranešta el. paštu",
    "Type a comment": "Spausdinti komentarą",
    "Send portal message": "Siųsti portalo žinutę",
    "Open timesheet": "Atidaryti darbo laiko apskaitos žiniaraštį",
    "Pause timer": "Stabdyti laikmatį",
    "Mark undone": "Žymėti kaip neatliktą",
    "Digitise": "Skaitmeninti",
    "Documents sent to digitisation": "Skaitmeninimui išsiųsti dokumentai",
    "Followers": "Sekėjai",
    "Start / Due date": "Pradžios data / terminas",
    "Select topic": "Pasirinkite temą",
    "1 document": "1 dokumentas",
    "{0} documents": "{0} dokumentas",
    "Download": "Parsisiųsti",
    "Download all": "Parsisiųsti viską",
    "Assign as task": "Priskirti kaip užduotį",
    "When selected, the task is sent as a task to the client": "Pasirinkus užduotį klientui siunčiama kaip užduotis",
    "Auto finish": "Automatinis užbaigimas",
    "When selected, the task is marked done after client finishes it": "Pasirinkus, užduotis pažymima kaip atlikta, kai klientas ją baigia",
    "Add comment / message": "Pridėti komentarą / pranešimą",
    "Add email": "Pridėti el. paštą",
    "Add estimation": "Pridėti įvertinimą",
    "Add task field": "Pridėti užduoties lauką",
    "Add dependency": "Pridėti priklausinį",
    "Drop files to upload": "Nuvilkite failus, kuriuos norite įkelti",
    "Task sent to client portal": "Užduotis išsiųsta į klientų portalą",
    "Task no longer assigned to client portal": "Užduotis nebepriskirta klientų portalui",
    "Save recurring task": "Išsaugoti pasikartojančią užduotį",
    "Add to-do list": "Pridėti reikiamų atlikti darbų sąrašą",
    "Waiting for event status: {0}": "Laukiama įvykio būsenos: {0}",
    "Waiting for project status: {0}": "Laukiama projekto būsenos: {0}",
    "Edit template task": "Redaguoti šablono užduotį",
    "Create recurring task": "Sukurkite pasikartojančią užduotį",
    "Make a copy": "Padaryti kopiją",
    "Add topic": "Pridėti temą",
    "Delete task": "Ištrinti užduotį",
    "Delete task template": "Ištrinti užduoties šabloną",
    "Select task field": "Pasirinkite užduoties lauką",
    "No custom fields available for this client": "Šiam klientui nėra pritaikytų laukelių",
    "task": "užduotis",
    "recurring task": "pasikartojanti užduotis",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Ar ketinate pašalinti save iš „{0}“, ar norite jį ištrinti visiškai?",
    "This {1} is shared with {0}": "Šis {1} yra bendrinamas su {0}",
    "Remove only me": "Pašalinti tik mane",
    "Time has been tracked to this task.": "Šiai užduočiai atlikti buvo skirtas laikas.",
    "Are you sure to delete this task?": "Ar tikrai norite ištrinti šią užduotį?",
    "Undefined": "Neapibrėžtas",
    "COPY": "KOPIJA",
    "On task due date": "Užduoties terminas",
    "{0} day before": "prieš {0} dieną",
    "{0} days before": "prieš {0} dienų",
    "Edit workflow": "Redaguoti darbo eigą",
    "Duplicate project": "Padaryti projekto kopiją",
    "Reset layout": "Iš naujo nustatyti išdėstymą",
    "Any time": "Bet kuriuo laiku",
    "Assign user...": "Priskirti vartotoją ...",
    "1 min": "1 min.",
    "5 min": "5 min.",
    "10 min": "10 min.",
    "30 min": "30 min.",
    "1 h": "1 val.",
    "Add notes": "Pridėti pastabų",
    "Task start date": "Užduoties pradžios data",
    "Task due date": "Užduoties atlikimo terminas",
    "Recurrence task": "Pasikartojimo užduotis",
    "Search from one time templates": "Paieška pagal vienkartinius šablonus",
    "Placeholders": "Vietaženkliai",
    "New task": "Nauja užduotis",
    "New recurring task": "Nauja pasikartojanti užduotis",
    "+1 day": "+1 diena",
    "Edit comment": "Redaguoti komentarą",
    "Timer is running!": "Laikmatis veikia!",
    "Continue time from {0}": "Tęskite laiką nuo {0}",
    "New time entry": "Naujas laiko įrašas",
    "Load more": "Įkelti daugiau",
    "Are you sure to delete this time entry?": "Ar tikrai ištrinsite šį laiko įrašą?",
    "Save automated email": "Išsaugoti automatizuotą el. laišką",
    "Automation": "Automatizavimas",
    "Are you sure to delete this email?": "Ar tikrai norite ištrinti šį el. laišką?",
    "Are you sure you wish to send this email immediately?": "Ar tikrai norite tuojau pat išsiųsti šį el. laišką?",
    "replied to project email": "atsakė į projekto el. laišką",
    "replied to client email": "atsakė į kliento el. laišką",
    "commented": "pakomentavo",
    "Reply": "Atsakyti",
    "Are you sure to delete this comment?": "Ar tikrai ištrinsite šį komentarą?",
    "replied to client portal email": "atsakė į kliento portalo el. laišką",
    "sent a message": "atsiuntė žinutę",
    "replied to task email": "atsakė į užduoties el. laišką",
    "failed to send": "nepavyko išsiųsti",
    "sent email": "išsiųstas el. laiškas",
    "no one": "Niekas",
    "created this task.": "sukūrė šią užduotį.",
    "Task was automatically created from forwarded e-mail": "Užduotis buvo sukurta automatiškai iš persiųsto el",
    "Task was automatically created from client portal e-mail": "Užduotis buvo automatiškai sukurta iš kliento portalo el. pašto",
    "Task was automatically created from client e-mail": "Užduotis buvo automatiškai sukurta iš kliento el. pašto",
    "Task was automatically created from project e-mail": "Užduotis buvo automatiškai sukurta iš projekto el. pašto",
    "requested assistance.": "paprašė pagalbos.",
    "updated this task.": "atnaujino šią užduotį.",
    "tracked time to this task.": "sekė šios užduoties laiką.",
    "finished this task.": "baigė šią užduotį.",
    "new comment.": "naujas komentaras.",
    "reassigned this task.": "perskyrė šią užduotį.",
    "assigned the task to {0}.": "paskyrė užduotį {0}.",
    "reminder.": "priminimas.",
    "deleted.": "ištrintas.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "įvykdė užduotį, tačiau Uku šios užduoties automatiškai neužbaigė, nes buvo įvykdyti ne visi užduoties reikalavimai.",
    "sent task to client portal": "išsiuntė užduotį į kliento portalą",
    "assigned the task to client.": "paskyrė užduotį klientui.",
    "assigned the task to company.": "paskyrė užduotį bendrovei.",
    "added attachment(s).": "pridėtas (-i) priedas (-ai).",
    "added a comment.": "pridėjo komentarą.",
    "added a message to {0}.": "pridėta žinutė prie {0}.",
    "received a e-mail from {0}.": "gavo el. laišką iš {0}.",
    "updated notes.": "atnaujintos pastabos.",
    "made changes to checklist.": "atlikti kontrolinio sąrašo pakeitimai.",
    "created this task template.": "sukūrė šį užduoties šabloną.",
    "updated this task template.": "atnaujino šį užduoties šabloną.",
    "recurring task assigned.": "paskirta pasikartojanti užduotis.",
    "recurring task deleted.": "ištrintos pasikartojančios užduotys.",
    "added email.": "pridėtas el. paštas.",
    "changed email.": "pakeistas el. paštas.",
    "deleted email.": "ištrintas el. paštas.",
    "sent email.": "išsiųstas el. paštu.",
    "failed to send.": "nepavyko išsiųsti.",
    "added email": "el. paštas pridėtas",
    "changed email": "el. paštas pakeistas",
    "deleted email": "el. paštas ištrintas",
    "Member / Time": "Narys / laikas",
    "Client/topic": "Klientas / tema",
    "Client/task": "Klientas / užduotis",
    "Client/member": "Klientas/narys",
    "Member/topic": "Narys/tema",
    "Member/task": "Narys/užduotis",
    "Member/client": "Narys/klientas",
    "Member/date": "Narys/data",
    "Date/member": "Data/narys",
    "Grouped": "Sugrupuota",
    "Client/project": "Klientas / projektas",
    "Project/member": "Projektas / narys",
    "Period balance": "Laikotarpio balansas",
    "Reset balance": "Iš naujo nustatyti balansą",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Laiko įrašas buvo patvirtintas arba trukmė buvo pakeista ir trukmė nebus dinamiškai atnaujinama",
    "(Without project)": "(Be projekto)",
    "Decline": "Atmesti",
    "Accept": "Priimti",
    "Cancel decision": "Atšaukti sprendimą",
    "Accepted": "Priimta",
    "Declined": "Atmesta ",
    "Report data has changed. Please update report.": "Ataskaitos duomenys pasikeitė. Atnaujinkite ataskaitą.",
    "Agreed": "Sutarta",
    "Non billable": "Neapmokestinama",
    "Export report to Excel": "Eksportuoti ataskaitą į „Excel“",
    "By default, we export the result of the selected filters with the columns of the configured table": "Pagal numatytuosius nustatymus mes eksportuojame pasirinktų filtrų rezultatus su sukonfigūruotos lentelės stulpeliais",
    "Add to export client custom fields": "Pridėti prie eksportuojamo kliento pasirinktinių laukų",
    "Save report": "Išsaugoti ataskaitą",
    "Export PDF": "Eksportuoti PDF",
    "Export Excel": "Eksportuoti „Excel“",
    "We have new version of": "Mes turime naują versiją",
    "Log out": "Atsijungti",
    "Previous day": "Ankstesnė diena",
    "Next day": "Kita diena",
    "Mark all as read": "Pažymėti visus kaip perskaitytus",
    "Search task/client": "Ieškoti užduoties/kliento",
    "from client portal": "iš klientų portalo",
    "Hide all": "Paslėpti viską",
    "Hide for 1 hour": "Paslėpti 1 valandą",
    "Something went wrong": "Kažkas ne taip",
    "User authentication needed": "Reikalingas vartotojo autentikavimas",
    "Invalid rights": "Negaliojančios teisės",
    "The object cannot be found": "Objekto rasti neįmanoma",
    "Content too large": "Turinys per didelis",
    "An unknown error occurred": "Įvyko nežinoma klaida",
    "The action requested cannot be performed": "Prašomo veiksmo atlikti negalima",
    "Go": "Eiti",
    "Actual / monitoring (month)": "Faktinis / stebėjimas (mėnuo)",
    "h": "val.",
    "Actual": "Faktinis",
    "Month": "Mėnuo",
    "I’m setting up your account": "Ruošiu jūsų paskyrą",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Ar žinojote, kad tos įmonės, kurios pradėjo naudoti „Uku\", dabar gali aptarnauti 38% daugiau klientų tuo pačiu metu.",
    "Let’s setup your company": "Sukonfigūruokime jūsų įmonę",
    "Name of your company": "Jūsų įmonės pavadinimas",
    "Size of your team?": "Jūsų komandos dydis?",
    "Which software are you using?": "Kokią programinę įrangą naudojate?",
    "This knowledge will help us to improve Uku": "Šios žinios padės mums patobulinti „„Uku\"\"",
    "What other software needs to be integrated?": "Kokią programinę įrangą dar reikės integruoti?",
    "Book a demo": "Užsisakykite konsultanto skambutį",
    "Hi {0},": "Labas {0},",
    "NO BOTS - ONLY HUMANS": "JOKIŲ BOTŲ - TIK ŽMONĖS",
    "Start a 14 day free trial": "Pradėkite 14 dienų nemokamą bandymą",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "„„Uku\"\" yra neįtikėtinai funkcionali programa. „„Uku\"\" pagerino mūsų darbo valdymą ir padeda teikti išskirtines paslaugas.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Greičiausias būdas nuspręsti, ar \"Uku\" gali būti naudinga {0}, yra trumpas {1} min. pokalbis su mūsų klientų įdarbinimo specialistu.",
    "Hi, I'm Uku ": "Sveiki, aš esu „Uku\" ",
    "I help to set up your account.": "Padedu susikurti jūsų profilį.",
    "It only takes a minute.": "Tai užtrunka tik minutę.",
    "Choose": "Pasirinkite",
    "Your country": "Savo šalį",
    "Your language": "Savo kalbą",
    "Begin": "Pradėti",
    "Let’s become friends": "Tapkime draugais",
    "Your first name": "Jūsų vardas",
    "What is your field of work?": "Kokia jūsų darbo sritis?",
    "Your field of work": "Jūsų darbo sritis",
    "How will you use Uku?": "Kaip naudosite „„Uku\"“?",
    "How did you hear about Uku?": "Iš kur sužinojote apie „„Uku\"“?",
    "Choose channel": "Pasirinkite kanalą",
    "Please specify how you heard about us": "Nurodykite, kaip sužinojote apie mus",
    "Let me know Uku's new features by email": "Praneškite man apie naujas „„Uku\"„ funkcijas el. paštu",
    "Finish": "Baigti",
    "First name is required": "Būtina nurodyti vardą",
    "Name is required": "Būtinas vardas",
    "Team size is required": "Būtinas komandos dydis",
    "Surname is required": "Butina nurodyti pavardę",
    "Field is required": "Laukelis privalomas",
    "I will use Uku to work together with two or more teammates.": "Naudosiu „Uku“ dirbti su dviem ar daugiau komandos narių.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "„Uku“ naudosiuosi pats vienas. Šis planas yra nemokamas, bet su ribotomis funkcijomis.",
    "Media": "Aplinka",
    "Through integration partner": "Iš integracijų partnerio",
    "Referral by friend": "Rekomendavo draugas",
    "Import speeds up your clients setup, smart choice!": "Importas pagreitina jūsų klientų sąranką – protingas pasirinkimas!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Paskutinis importavimas: pridėta {0}, atnaujinta {1}, praleista {2}, nepavyko importuoti klientų {3}",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Paskutinis importavimas: pridėta {0}, atnaujinta {1}, praleista {2}, nepavyko importuoti klientų {3}",
    "Last import: added {0}, updated {1}, skipped {2}": "Paskutinis importavimas: pridėta {0}, atnaujinta {1}, praleista {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Kas toliau? Pataisykite {0} klientų duomenis ir įkelkite dar kartą.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "„Excel“ (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Užuot įvedę klientus po vieną, galite naudoti failų importą didelei klientų bazei.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Importuokite visus „Merit Aktiva“ klientus ir automatiškai atnaujinkite klientų duomenis",
    "Ignore": "Nepaisyti",
    "NEW CLIENT": "NAUJAS KLIENTAS",
    "Preview": "Peržiūra",
    "Import started": "Importavimas prasidėjo",
    "Only new clients": "Tik nauji klientai",
    "Update data from company register": "Atnaujinti duomenis iš įmonių registro",
    "If switched on, the company data is updated using the local business register": "Įjungus, įmonės duomenys atnaujinami naudojant vietinį įmonių registrą",
    "We did not find a match in Äriregister": "Äriregister atitikmens neradome",
    "We did not find a match in Companies House": "\"Companies House\" neradome atitikmens",
    "No integration yet": "Integracijos dar nėra",
    "Uku match": "„Uku“ atitikmuo",
    "Business register nr.": "Verslo registracijos Nr.",
    "Company register": "Įmonės registras",
    "Upload file": "Įkelti failą",
    "Before uploading your file": "Prieš įkeliant failą",
    "Learn Uku’s data structure": "Sužinokite „Uku“ duomenų struktūrą",
    "Download and use our sample file to see exactly how we organize data in Uku": "Atsisiųskite ir naudokite mūsų pavyzdinį failą, kad pamatytumėte, kaip tiksliai tvarkomi duomenys su „Uku“",
    "Download Client Import Example": "Atsisiųsti klientų importavimo pavyzdį",
    "Download Contact Import Example": "Atsisiųsti kontaktų importavimo pavyzdį",
    "Fill in fields": "Užpildykite laukus",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Vienintelis privalomas laukas yra įmonės pavadinimas. Prieš įkeldami failą įsitikinkite, kad užpildėte visus būtinus laukus.",
    "Learn more about mandatory fields": "Sužinokite daugiau apie privalomus laukus",
    "Create custom fields": "Kurti pasirinktinius laukus",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Kai kurių duomenų laukų pagal numatytuosius nustatymus gali nebūti. Prieš importuodami duomenis būtinai sukurkite šiuos pasirinktinius laukus.",
    "Add new custom fields": "Pridėti naujų pasirinktinių laukų",
    "...or drag a file here": "...arba vilkite failą čia",
    "Only Excel (.xls, .xlsx) file types are supported": "Palaikomi tik „Excel“ (.xls, .xlsx) failų tipai",
    "Mapping": "Sudaroma",
    "First row is a header": "Pirmoji eilutė yra antraštė",
    "Add field to all clients": "Pridėti laukelių visiems klientams",
    "Add client group": "Pridėti klientų grupę",
    "Fields for all clients": "Laukai visiems klientams",
    "Import of {0} in progress": "Vyksta {0} importavimas",
    "Import in progress": "Vyksta importavimas",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Tai gali šiek tiek užtrukti. Tuo pat metu „Uku“ platformojejūs galite užsiimti kita veikla – informuosime jus, kai viskas bus paruošta.",
    "Cancel import": "Atšaukti importavimą",
    "Are you sure you want to cancel import?": "Ar tikrai norite atšaukti importavimą?",
    "Last updated": "Paskutinį kartą atnaujinta",
    "Contracts": "Sutartys",
    "Job name": "Darbo pavadinimas",
    "Workflow name": "Darbo eigos pavadinimas",
    "Details": "Informacija",
    "Select jobs": "Pasirinkite darbus",
    "Select task plan": "Pasirinkite užduoties planą",
    "of existing client": "esamo kliento",
    "You can also choose": "Taip pat galite pasirinkti",
    "existing client tasks plan": "esamą kliento užduočių planą",
    "existing predefined jobs": "esamus iš anksto nustatytus darbus",
    "create a new plan": "sukurti naują planą",
    "Select workflow": "Pasirinkite darbo eigą",
    "existing project workflow": "esamo projekto darbo eiga",
    "existing workflow": "esama darbo eiga",
    "create a new workflow": "sukurti naują darbo eigą",
    "New tasks template": "Naujas užduočių šablonas",
    "to save template!": "išsaugoti šabloną!",
    "You can also add tasks from jobs": "Taip pat galite pridėti užduotis iš darbų",
    "or choose": "arba pasirinkti",
    "New workflow template": "Naujas darbo eigos šablonas",
    "You can also add tasks from existing workflow templates": "Taip pat galite pridėti užduotis iš esamos darbo eigos šablonų",
    "existing event workflow": "esamo įvykio darbo eiga",
    "Hide others": "Slėpti kitus",
    "Update all events (New tasks)": "Atnaujinti visus įvykius (Naujos užduotys)",
    "Update all projects (New tasks)": "Atnaujinti visus projektus (Naujos užduotys)",
    "Once": "Kartą",
    "Once a month": "Kartą per mėnesį",
    "Once a quarter": "Kartą per ketvirtį",
    "Once a year": "Kartą per metus",
    "Company workflow": "Įmonės darbo eiga",
    "Company jobs": "Įmonės darbai",
    "Default jobs": "Numatytieji darbai",
    "ID": "ID",
    "Task title and labels": "Užduoties pavadinimas ir etiketės",
    "Assigned and time": "Priskirta ir laikas",
    "Setup tasks for {0} event": "{0} įvykio sąrankos užduotys",
    "Setup tasks for {0} project": "{0} projekto sąrankos užduotys",
    "New job": "Naujas darbas",
    "Edit job": "Redaguoti darbą",
    "New workflow": "Nauja darbo eiga",
    "Save workflow": "Išsaugoti darbo eigą",
    "Create task plan": "Sukurti užduoties planą",
    "Confirm task plan": "Patvirtinti užduoties planą",
    "Skip": "Praleisti",
    "Confirm workflow": "Patvirtinti darbo eigą",
    "Client portal templates": "Klientų portalo šablonai",
    "Jobs": "Darbai",
    "Workflows": "Darbo eigos",
    "Company workflows": "Įmonės darbo eigos",
    "Default workflows": "Numatytosios darbo eigos",
    "Company template saved": "Išsaugotas įmonės šablonas",
    "Company template created": "Sukurtas įmonės šablonas",
    "Format": "Formatas",
    "Currency": "Valiuta",
    "Reference number": "Nuorodos numeris",
    "Invoice description": "Sąskaitos faktūros aprašymas",
    "Summarize invoice rows": "Apibendrinti sąskaitų faktūrų eilutes",
    "Summarized description": "Apibendrintas aprašymas",
    "Reverse charge": "Atvirkštinis apmokestinimas",
    "Rounding": "Apvalinimas",
    "Time rounding will apply for each line": "Kiekvienai eilutei taikomas laiko apvalinimas",
    "Rounding increment (up)": "Apvalinimas (aukštyn)",
    "Reply to": "Atsakyti",
    "Configuration": "Konfigūracija",
    "Invoice to parent company": "Sąskaita faktūra patronuojančiai bendrovei",
    "Create all invoices under parent company.": "Sukurkite visas sąskaitas faktūras pagal patronuojančiąją įmonę.",
    "User code": "Vartotojo kodas",
    "Default": "Numatytas",
    "Default value will apply for each line": "Numatytoji vertė bus taikoma kiekvienai eilutei",
    "Number": "Skaičius",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Į sąskaitos faktūros priešdėlio lauką galite įrašyti bet kurį iš toliau išvardytų elementų, įrašytų lenktiniuose skliaustuose. Išsaugant sutartį priešdėlis užpildomas atitinkama verte.",
    "Copy to clipboard": "Kopijuoti į iškarpinę",
    "Invoice previous period": "Išrašyti sąskaitą už prieš tai buvusį laikotarpį",
    "Invoice period": "Sąskaitos faktūros laikotarpis",
    "Invoice next period": "Išrašyti sąskaitą faktūrą už sekantį laikotarpį",
    "Client primary user": "Kliento pirminis vartotojas",
    "Original client name": "Pirminis kliento pavadinimas",
    "invoice date year": "sąskaitos faktūros datos metai",
    "last two digits of invoice date year": "paskutiniai du sąskaitos faktūros datos metų skaitmenys",
    "invoice date month": "sąskaitos faktūros datos mėnuo",
    "invoice date day": "sąskaitos faktūros datos diena",
    "Copied to clipboard": "Nukopijuota į iškarpinę",
    "Contract": "Sutartis",
    "Net total": "Grynoji suma",
    "Contract #": "Sutartis #",
    "Invoice #": "Sąskaita faktūra Nr.",
    "Exported": "Eksportuota",
    "Sent": "Išsiųsta",
    "Net": "Tinklas",
    "Add invoice": "Pridėti sąskaitą faktūrą",
    "Change invoice number": "Keisti sąskaitos faktūros numerį",
    "Review changes": "Peržiūrėti pakeitimus",
    "Please review and approve changes to the related events": "Peržiūrėkite ir patvirtinkite susijusių įvykių pakeitimus",
    "Please review and approve changes to the related projects": "Peržiūrėkite ir patvirtinkite susijusių projektų pakeitimus",
    "Contains": "Turi",
    "contains": "turi",
    "Exactly": "Tiksliai",
    "is exactly": "yra tiksliai",
    "Greater than": "Didesnis nei",
    "is greater than": "yra didesnis nei",
    "Less than": "Mažiau nei",
    "is less than": "yra mažiau nei",
    "Range": "Diapazonas",
    "is in range of": "yra diapazone",
    "is empty": "yra tuščias",
    "Task plan": "Užduoties planas",
    "Edit plan": "Redaguoti planą",
    "Use task plan templates to set up tasks effectively or add a task manually": "Naudokite užduočių plano šablonus, kad veiksmingai nustatytumėte užduotis, arba pridėkite užduotį rankiniu būdu",
    "Add task manually": "Pridėkite užduotį rankiniu būdu",
    "Quarterly": "Kas ketvirtį",
    "Export excel": "Eksportuoti Excel",
    "Print PDF": "Spausdinti PDF",
    "Edit jobs": "Redaguoti darbus",
    "Replace plan tasks with job": "Plano užduotis pakeisti darbu",
    "Select template": "Pasirinkite šabloną",
    "member": "narys",
    "Tasks with user will be added to every selected client": "Užduotys su vartotoju bus pridėtos prie kiekvieno pasirinkto kliento",
    "Add even if job already applied": "Pridėti, net jei darbo vieta jau pritaikyta",
    "Default user": "Numatytasis vartotojas",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Taip iš kliento plano bus ištrintos visos užduotys ir į jį bus įtrauktos tik pasirinkto šablono užduotys",
    "Adding template will be ready in a minute. You can continue with work.": "Šablonas pridėti bus paruoštas per minutę. Galite tęsti darbą.",
    "Add client": "Pridėti klientą",
    "Export clients": "Eksportuoti klientus",
    "Export client contacts": "Eksportuoti kliento kontaktus",
    "client | clients": "klientas | klientai",
    "clients": "klientai",
    "client(s) had errors": "klientas (-ai) turėjo klaidų",
    "client(s) selected": "pasirinktas (-i) klientas (-ai)",
    "Contract actions": "Sutarties veiksmai",
    "Edit Members": "Redaguoti narius",
    "Edit monitoring": "Redaguoti stebėjimą",
    "Your company": "Tavo įmonė",
    "Edit billing": "Redaguoti atsiskaitymą",
    "Activate client portal": "Suaktyvinti klientų portalą",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Aktyvavę galite siųsti užduotis tiesiogiai visiems kliento kontaktams, kurie turi el. pašto adresą.",
    "Send welcome invitation to client contacts": "Siųskite kvietimus klientų kontaktams",
    "Who will receive an invitation?": "Kas gaus kvietimą?",
    "Client contact who has one valid e-mail address": "Kliento kontaktas, turintis vieną galiojantį el. pašto adresą",
    "Client contact who has the client's portal open (default for all)": "Kliento kontaktinis asmuo, kurio portalas atidarytas (pagal numatytuosius nustatymus visiems)",
    "How does the invitation work?": "Kaip veikia kvietimas?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "\"Uku\" sukuria ir siunčia \"Pasveikinimo užduotį\" kiekvienam kliento kontaktui. Ją sukuria pagrindinis kliento naudotojas pagal užduoties \"Sveiki atvykę į klientų portalą\" šabloną. Peržiūrėkite jį savo įmonės užduočių šablonų skiltyje. Ji bus išversta pagal kontakto kalbą.",
    "Uku client portal always informs clients by email about new tasks.": "\"Uku\" klientų portalas visada informuoja klientus el. paštu apie naujas užduotis.",
    "View templates": "Peržiūrėti šablonus",
    "Client portal activated": "Įjungtas klientų portalas",
    "Company's name": "Įmonės pavadinimas",
    "Mark": "Žyma",
    "Add members": "Pridėti narius",
    "Members and groups": "Nariai ir grupės",
    "Topic is required": "Būtina tema",
    "Entering time is required": "Būtina įvesti laiką",
    "Delete client": "Ištrinti klientą",
    "Manage client fields": "Tvarkyti kliento laukus",
    "Max 3 characters": "Daugiausiai 3 simboliai",
    "Are you sure you wish to delete this client?": "Ar tikrai norite ištrinti šį klientą?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Ištrynus kliento duomenis, bus ištrintos ir visos su klientu susijusios užduotys.<br/><br/>NB! Kliento istorija bus ištrinta",
    "Owner": "Savininkas",
    "All clients that you add under {0} will be deleted later.</div>": "Visi klientai, kuriuos pridėsite kaip {0}, vėliau bus ištrinti.</div>",
    "Use this account for testing purposes only!": "Šią paskyrą naudokite tik testavimo tikslais!",
    "Read more about the demo account": "Skaitykite daugiau apie bandomąją paskyrą",
    "Rights": "Teisės",
    "Monitoring setup": "Stebėjimo konfigūracija",
    "Learn more about monitoring": "Sužinokite daugiau apie stebėjimą",
    "selected": "pasirinktas",
    "Invoicing": "Sąskaitų faktūrų išrašymas",
    "Billing template": "Apmokestinimo šablonas",
    "New": "Naujas",
    "Add row": "Pridėti eilutę",
    "Delete contract": "Ištrinti sutartį",
    "Product / description": "Produktas/aprašymas",
    "Qty": "Kiekis",
    "Product placeholders": "Produkto vietaženkliai",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "Produkto aprašyme galite įrašyti bet kurią iš šių eilučių lenktuose skliaustuose. Išsaugant sąskaitą faktūrą tekstas bus pakeistas atitinkama reikšme.",
    "Template saved": "Šablonas išsaugotas",
    "Warning": "Įspėjimas",
    "Would you like to apply these changes to all clients using this contract template?": "Ar norite padaryti šiuos pakeitimus visiems klientams naudojant šį sutarties šabloną?",
    "Yes, apply to all clients": "Taip, taikyti visiems klientams",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Jūs pakeitėte laikotarpį, kuriam taikoma ši apmokestinimo sutartis. Tai gali pakeisti sąskaitas už paveiktas neapmokėtas paslaugas praeityje ir ateityje. Patvirtinkite, kad šis pakeitimas buvo iš anksto apgalvotas.",
    "Are you sure to delete this template?": "Ar tikrai norite ištrinti šį šabloną?",
    "Save template": "Išsaugoti šabloną",
    "Save as template": "Išsaugoti kaip šabloną",
    "Please note all changes made to contract will be lost": "Turėkite omenyje, kad visi pakitimai padaryti sutarčiai, bus prarasti",
    "Add contract": "Pridėti sutartį",
    "Manage contract templates": "Tvarkyti sutarčių šablonus",
    "Change account details": "Keisti sąskaitos informaciją",
    "Country is required": "Būtina nurodyti šalį",
    "Address": "Adresas",
    "Postal code": "Pašto kodas",
    "State": "Valstija",
    "Uku is set up according to the field of work.": "„„Uku\"\" nustatytas atsižvelgiant į darbo sritį.",
    "Size of the team": "Komandos dydis",
    "Website": "Tinklapis",
    "Delete account": "Ištrinti paskyrą",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Ištrynus paskyrą, bus ištrinti visi su paskyra susieti klientai, jų užduotys ir visa jų istorija. Ar tikrai norite ištrinti savo sąskaitą?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Taip, ištrinkite paskyrą su visais susijusiais duomenimis, tokiais kaip klientai, užduotys ir visa istorija",
    "These invoices cannot be sent. Check their status or error messages.": "Šios sąskaitos faktūros negali būti siunčiamos. Patikrinkite jų būseną arba klaidos pranešimus.",
    "Please confirm that you wish to proceed.": "Patvirtinkite, kad norite tęsti.",
    "Sending invoice | Sending invoices": "Siunčiama sąskaita faktūra | Siunčiamos sąskaitos faktūros",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Ketinate išsiųsti šią sąskaitą el. paštu klientui. | Ketinate išsiųsti šias sąskaitas klientams el. paštu.",
    "Error in calculating invoice": "Klaida apskaičiuojant sąskaitą faktūrą",
    "Error in importing invoice": "Klaida importuojant sąskaitą faktūrą",
    "Error in creating invoice": "Kuriant sąskaitą faktūrą įvyko klaida",
    "Error in exporting invoice": "Eksportuojant sąskaitą faktūrą įvyko klaida",
    "Error in sending invoice": "Siunčiant sąskaitą faktūrą įvyko klaida",
    "Calculating invoice": "Skaičiuojama sąskaita",
    "Creating invoice": "Kuriama sąskaita faktūra",
    "Exporting invoice": "Eksportuojama sąskaita faktūra",
    "Importing invoice": "Importuojama sąskaita faktūra",
    "Sending invoice": "Siunčiama sąskaita",
    "Clear errors": "Išvalyti klaidas",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Susiję darbai vėl bus apmokestinami. Sąskaitos faktūros nebus ištrintos iš išorinių sistemų, turėsite tai padaryti rankiniu būdu.",
    "Delete invoice | Deleting invoices": "Ištrinti sąskaitą faktūrą | Sąskaitų faktūrų ištrynimas",
    "Selected net total": "Pasirinkta grynoji suma",
    "Nothing in invoices": "Sąskaitose faktūrose nieko nėra",
    "Please make sure you have setup recurring billing for your clients": "Įsitikinkite, kad nustatėte pasikartojantį sąskaitų išrašymą savo klientams",
    "Draft": "Juodraštis",
    "Approval": "Patvirtinimas",
    "Created": "Sukurta",
    "Coming soon": "Netrukus",
    "Selected invoices and related product info will be sent to accounting system.": "Pasirinktos sąskaitos faktūros ir susijusi informacija apie produktą bus išsiųsta į apskaitos sistemą.",
    "Piece": "Vienetas",
    "Hour": "Valanda",
    "Delete row": "Ištrinti eilutę",
    "Out of ": "Iš ",
    " can be created": "galima sukurti",
    "For ": "Dėl ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "sąskaitų išrašymo laikotarpis vis dar tęsiasi. Bet koks darbas, atliktas per šį laikotarpį po sąskaitos faktūros sukūrimo, nebus apmokestintas.",
    "Invoice date will be set to today.": "Sąskaitos faktūros data bus nustatyta šiandiena.",
    "Uku is about to create": "„„Uku\"\" ruošiasi sukurti",
    " selected row, only | selected row, only ": "tik pasirinkta eilutė | tik pasirinkta eilutė ",
    " invoice | invoices": "sąskaita faktūra | sąskaitos faktūros",
    "These invoices cannot be exported. Check their status or error messages.": "Šių sąskaitų faktūrų negalima eksportuoti. Patikrinkite jų būseną arba klaidos pranešimus.",
    "Exporting invoice | Exporting invoices": "Eksportuojama sąskaita faktūra | Eksportuojamos sąskaitos faktūros",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Ši sąskaita faktūra tuoj bus eksportuota apskaitai. | Šios sąskaitos faktūros tuoj bus eksportuotos apskaitai.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "Ši sąskaita faktūra jau eksportuota. Ar tikrai norite eksportuoti ją kaip naują sąskaitą faktūrą? | Kai kurios iš šių sąskaitų faktūrų jau eksportuotos. Ar tikrai norite jas eksportuoti kaip naujas sąskaitas faktūras?",
    "Download pdf": "Atsisiųsti pdf",
    "Create invoice": "Sukurti sąskaitą faktūrą",
    "Update status from {0}": "Atnaujinti būseną iš {0}",
    "Show all lines": "Rodyti visas linijas",
    "Calculate invoice": "Apskaičiuoti sąskaitą faktūrą",
    "Loading invoice...": "Įkeliama sąskaita faktūra ...",
    "Invalid Scoro credentials": "Netinkami „Scoro“ įgaliojimai",
    "Please confirm the changes you have made to this invoice.": "Patvirtinkite pakeitimus, kuriuos atlikote šioje sąskaitoje faktūroje.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Atminkite, kad pakeista sąskaita nebus automatiškai išsiųsta klientui ar eksportuota į išorines sistemas - turėsite tai padaryti rankiniu būdu.",
    "Invoice number already exists! Please confirm to save anyway.": "Toks sąskaitos faktūros numeris jau egzistuoja! Patvirtinkite, ar vis tiek norite išsaugoti.",
    "Error in data": "Duomenų klaida",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Sąskaitų faktūrų išrašymo laikotarpis vis dar tęsiasi. Bet koks darbas, atliktas per šį laikotarpį po sąskaitos faktūros sukūrimo, nebus išrašytas.",
    "Creation date": "Sukūrimo data",
    "{0} days after": "po {0} d.",
    "{0} day after": "po {0} d.",
    "right away when": "nedelsiant, kai",
    "start date": "pradžios data",
    "due date": "termino data",
    "finished": "baigta",
    "Entries count": "Įrašų skaičius",
    "Entries excluding sales": "Įrašai, išskyrus pardavimus",
    "Entries excluding bank": "Įrašai, išskyrus banką",
    "Entries excluding documents": "Įrašai, išskyrus dokumentus",
    "Documents (sales and purchases)": "Dokumentai (pirkimai ir pardavimai)",
    "Cash entries": "Kasos įrašai",
    "VAT entries": "PVM įrašai",
    "Stock entries": "Atsargų įrašai",
    "Sale entries": "Pardavimų įrašai",
    "Purchase entries": "Pirkimų įrašai",
    "Bank entries": "Banko įrašai",
    "Ledger entries": "Didžiosios knygos įrašai",
    "Depreciation entries": "Nusidėvėjimo įrašai",
    "Entry lines count": "Įrašo eilučių skaičius",
    "Company owner": "Įmonės savininkas",
    "Activity": "Veikla",
    "Oldest first": "Pirmiau seniausi",
    "Newest first": "Pirmiau naujausi",
    "Quantity as time": "Kiekis kaip laikas",
    "Quantity as number": "Kiekis kaip skaičius",
    "Quantity as time in number format": "Kiekis kaip laikas skaičių formatu",
    "No rounding": "Jokio apvalinimo",
    "min": "min.",
    "hour": "valanda",
    "Last day of month": "Paskutinė mėnesio diena",
    "Invoice line": "Sąskaitos faktūros eilutė",
    "Task time total (per member)": "Bendras užduoties laikas (vienam nariui)",
    "Time entry": "Laiko įvedimas",
    "Task finish date": "Užduoties užbaigimo data",
    "Create separately": "Sukurti atskirai",
    "Merge into one": "Sujungti į vieną",
    "No minimum": "Nėra minimalaus",
    "{0} minute": "{0} minutė",
    "{0} minutes": "{0} minučių",
    "{0} hour": "{0} valanda",
    "{0} hours": "{0} valandos",
    "English": "Anglų",
    "Estonian": "Estų",
    "Danish": "Danų",
    "Lithuanian": "Lietuvių",
    "Russian": "Rusų",
    "Finnish": "Suomių",
    "Swedish": "Švedų",
    "Norwegian": "Norvegų",
    "Latvian": "Latvių",
    "Bulgarian": "Bulgarų",
    "German": "Vokiečių",
    "Spanish": "Ispanų",
    "Polish": "Lenkų",
    "Field: ": "Laukas: ",
    "Normal hours": "Įprastos valandos",
    "Year": "Metai",
    "Estonia": "Estija",
    "Finland": "Suomija",
    "Poland": "Lenkija",
    "Connection successful!": "Prisijungimas sėkmingas!",
    "User": "Vartotojas",
    "None": "Joks",
    "Error!": "Klaida!",
    "Pending": "Laukia",
    "Finished": "Baigta",
    "Text": "Tekstas",
    "Choice": "Pasirinkimas",
    "Yes/No": "Taip/Ne",
    "Integer": "Sveikasis skaičius",
    "Multiple choice": "Keli pasirinkimai",
    "URL": "URL",
    "Multiple users": "Keli vartotojai",
    "Multiline text": "Tekstas per kelias eilutes",
    "Must be a integer": "Turi būti sveikas skaičius",
    "Must be a date": "Turi būti data",
    "Must be a valid e-mail address": "Turi būti galiojantis elektroninio pašto adresas",
    "Unknown choice": "Nežinomas pasirinkimas",
    "Some errors occurred:": "Įvyko keletas klaidų:",
    "Unknown network error": "Nežinoma tinklo klaida",
    "Could not connect to the service": "Nepavyko prisijungti prie paslaugos",
    "Reload this page": "Įkelkite šį puslapį iš naujo",
    "Invoice paid": "Sąskaita apmokėta",
    "Annulled": "Anuliuota",
    "Processing": "Apdorojimas",
    "You are about to deactivate this app.": "Jūs ketinate išjungti šią programą.",
    "You are about to disconnect this app.": "Netrukus atjungsite šią programą.",
    "Do you also want to activate billing to get the most out of Uku?": "Ar taip pat norite aktyvuoti atsiskaitymą, kad maksimaliai išnaudotumėte „Uku“?",
    "Invoice": "Sąskaita faktūra",
    "Clients - Monitoring": "Klientai - Stebėjimas",
    "Links": "Nuorodos",
    "New template": "Naujas šablonas",
    "Import Clients from Excel": "Importuoti klientus iš Excel",
    "Importer": "Importuotojas",
    "Import clients from Excel": "Importuoti klientus iš „Excel“",
    "Account settings": "Paskyros nustatymai",
    "Empty": "Tuščia",
};
export default translations